import React, { useEffect, useLayoutEffect, useRef, useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { postDeepSynastry } from '../../services/synastryApi';
import { saveDeepSynastry, listSavedSynastries, getSavedSynastryById } from '../../services/savedSynastryApi';
import placeApi from '../../services/placeApi';
import PlaceAutocomplete from '../../components/astrology/PlaceAutocomplete';
import useSynastryInterpretation from '../../hooks/useSynastryInterpretation';
import GuidedQuestionsPanel from '../../components/synastry/interpretation/GuidedQuestionsPanel';
import { clearLegacySavedSynastryStorage } from '../../utils/synastryPrivateStorage';
import { isEnglishPresentation, localizedServerContent, localizedValue } from '../../localization/presentationLanguage';

const synText = (es, en) => localizedValue({ es, en });


const styles = {
wrapper: {
  position: 'relative',
  gap: 18,
  width: '100%',
  paddingBottom: 40,
  background: 'transparent',
  minHeight: '100%',
  display: 'flex',
  flexDirection: 'column',

  /* FIX SCROLL MOBILE: no captura el gesto; scrollea el padre */
  overflow: 'visible',
  overscrollBehaviorY: 'auto',
  touchAction: 'pan-y',
  WebkitOverflowScrolling: 'touch',
  contain: 'layout paint',
},
  helperStrong: {
    color: '#F7D774',
    fontWeight: 800,
  },
  microBadge: {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 6,
  minHeight: 24,
  padding: '0 10px',
  borderRadius: 999,
  border: '1px solid rgba(218,165,32,0.22)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.09) 0%, rgba(255,255,255,0.045) 100%)',
  color: '#FFF3C4',
  fontSize: 11,
  fontWeight: 900,
  letterSpacing: 0.32,
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.06)',
},
card: {
  position: 'relative',
  zIndex: 1,
  borderRadius: 30,
  padding: 20,
  border: '1px solid rgba(247,215,116,0.48)',
  background:
    'linear-gradient(180deg, rgba(20,11,38,0.95) 0%, rgba(10,7,20,0.985) 100%)',
  backdropFilter: 'none',
  WebkitBackdropFilter: 'none',
  boxShadow: '0 8px 20px rgba(0,0,0,0.24), inset 0 1px 0 rgba(255,255,255,0.04)',
  overflow: 'visible',
  transition: 'border-color 160ms ease',
  flexShrink: 0,
},
  intro: {
  position: 'relative',
  zIndex: 1,
  overflow: 'clip',
  borderRadius: 26,
  padding: 22,

  border: '1px solid rgba(247,215,116,0.24)',
  background: 'linear-gradient(135deg, rgba(75,0,130,0.28) 0%, rgba(15,10,28,0.90) 62%, rgba(218,165,32,0.10) 100%)',

  boxShadow: '0 18px 56px rgba(0,0,0,0.28), 0 0 24px rgba(138,43,226,0.10)',
  backdropFilter: 'none',
  WebkitBackdropFilter: 'none',

  height: 'auto',
  minHeight: 'unset',
  maxHeight: 'none',
  flex: '0 0 auto',
  alignSelf: 'stretch',
  flexShrink: 0,

  pointerEvents: 'none',
  userSelect: 'none',
},
  introTitle: {
  margin: 0,
  fontSize: 19,
  fontWeight: 900,
  color: '#FFF3C4',
  textShadow: '0 0 12px rgba(247,215,116,0.18)',
},
  introText: {
    margin: '10px 0 0',
    color: 'rgba(255,243,196,0.82)',
    lineHeight: 1.65,
    fontSize: 14,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0,1fr))',
    gap: 16,
  },
  gridMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
  },
  profileCard: {
    position: 'relative',
    overflow: 'visible',
    borderRadius: 24,
    padding: 18,
    border: '1px solid rgba(247,215,116,0.34)',
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.07) 0%, rgba(255,255,255,0.022) 100%)',
    boxShadow: '0 6px 16px rgba(0,0,0,0.20), inset 0 1px 0 rgba(255,255,255,0.04)',
    transition: 'border-color 160ms ease',
  },
  profileHeader: {
    margin: '0 0 14px',
    fontSize: 16,
    fontWeight: 900,
    color: '#FFF3C4',
  },
  fieldWrap: {
    display: 'flex',
    flexDirection: 'column',
    gap: 7,
    marginBottom: 12,
  },
  fieldHeaderRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 8,
    flexWrap: 'wrap',
  },
  fieldPill: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    minHeight: 20,
    padding: '0 8px',
    borderRadius: 999,
    border: '1px solid rgba(218,165,32,0.16)',
    background: 'rgba(255,255,255,0.035)',
    color: 'rgba(255,243,196,0.78)',
    fontSize: 10,
    fontWeight: 800,
    letterSpacing: 0.3,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
  },
  readonlyInput: {
    background: 'rgba(255,255,255,0.03)',
    color: 'rgba(255,243,196,0.84)',
    border: '1px solid rgba(218,165,32,0.14)',
  },
  lockedPlaceButton: {
  width: '100%',
  minWidth: 0,
  minHeight: 52,
  borderRadius: 16,
  border: '1px solid rgba(218,165,32,0.18)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.03) 100%)',
  color: 'rgba(255,243,196,0.88)',
  padding: '0 14px',
  fontSize: 16,
  textAlign: 'left',
  boxSizing: 'border-box',
  cursor: 'pointer',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05), 0 8px 18px rgba(0,0,0,0.10)',
  touchAction: 'pan-y',
},
  inlineGhostButton: {
  minHeight: 34,
  borderRadius: 999,
  border: '1px solid rgba(247,215,116,0.35)',

  background:
    'linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(247,215,116,0.06) 100%)',

  color: '#F7D774',
  fontSize: 11,
  fontWeight: 900,
  letterSpacing: 0.35,
  textTransform: 'uppercase',
  padding: '0 12px',

  cursor: 'pointer',

  boxShadow:
    '0 10px 22px rgba(0,0,0,0.25), 0 0 14px rgba(247,215,116,0.18), inset 0 1px 0 rgba(255,255,255,0.06)',

  transition: 'border-color 140ms ease, opacity 140ms ease',
},
  selectedPlaceCard: {
  borderRadius: 16,
  padding: 13,
  border: '1px solid rgba(218,165,32,0.14)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.045) 0%, rgba(255,255,255,0.025) 100%)',
  display: 'grid',
  gap: 5,
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
},
  selectedPlaceTitle: {
    margin: 0,
    color: '#FFF3C4',
    fontSize: 13,
    fontWeight: 800,
    lineHeight: 1.45,
  },
  selectedPlaceMeta: {
    margin: 0,
    color: 'rgba(255,243,196,0.64)',
    fontSize: 12,
    lineHeight: 1.5,
  },
  selectedPlaceSummary: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 4,
  },
  techToggle: {
    marginTop: 8,
    padding: 0,
    border: 'none',
    background: 'transparent',
    color: '#F7D774',
    fontSize: 12,
    fontWeight: 800,
    cursor: 'pointer',
    textAlign: 'left',
  },
  techPanel: {
    marginTop: 10,
    borderRadius: 12,
    padding: 10,
    border: '1px solid rgba(218,165,32,0.10)',
    background: 'rgba(255,255,255,0.025)',
    display: 'grid',
    gap: 8,
  },
  techGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
    gap: 8,
  },
  techGridMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 8,
  },
  techStat: {
    borderRadius: 10,
    padding: 10,
    border: '1px solid rgba(255,255,255,0.05)',
    background: 'rgba(255,255,255,0.02)',
  },
  techStatLabel: {
    margin: 0,
    color: 'rgba(255,243,196,0.58)',
    fontSize: 11,
    fontWeight: 800,
    textTransform: 'uppercase',
    letterSpacing: 0.3,
  },
  techStatValue: {
    margin: '4px 0 0',
    color: '#FFF3C4',
    fontSize: 13,
    fontWeight: 800,
    lineHeight: 1.4,
    wordBreak: 'break-word',
  },
  label: {
    fontSize: 12,
    fontWeight: 800,
    textTransform: 'uppercase',
    letterSpacing: 0.35,
    color: 'rgba(255,243,196,0.72)',
  },
  input: {
  width: '100%',
  minWidth: 0,
  height: 52,
  borderRadius: 16,
  border: '1px solid rgba(218,165,32,0.20)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.055) 0%, rgba(255,255,255,0.03) 100%)',
  color: '#FFF3C4',
  padding: '0 14px',
  fontSize: 16,
  outline: 'none',
  boxSizing: 'border-box',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05), 0 8px 18px rgba(0,0,0,0.12)',
  touchAction: 'pan-y',
},
  checkboxRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
    color: '#FFF3C4',
    fontSize: 14,
    fontWeight: 700,
  },
  helper: {
    marginTop: 6,
    fontSize: 12,
    color: 'rgba(255,243,196,0.62)',
    lineHeight: 1.5,
  },
  buttonRow: {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  flexWrap: 'wrap',
  marginTop: 6,
},
  actionRow: {
  display: 'flex',
  alignItems: 'stretch',
  gap: 12,
  flexWrap: 'wrap',
  width: '100%',
  marginTop: 10,
},
  actionRowMobile: {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 12,
  width: '100%',
  marginTop: 4,
},
  secondaryButton: {
  minHeight: 54,
  borderRadius: 16,
  border: '1px solid rgba(247,215,116,0.45)',

  background:
    'linear-gradient(135deg, rgba(255,255,255,0.12) 0%, rgba(247,215,116,0.10) 45%, rgba(138,43,226,0.10) 100%)',

  color: '#FFF3C4',
  fontWeight: 900,
  fontSize: 14,
  padding: '0 18px',
  cursor: 'pointer',

  boxShadow:
    '0 18px 44px rgba(0,0,0,0.36), 0 0 26px rgba(247,215,116,0.28), inset 0 1px 0 rgba(255,255,255,0.08)',

  transition: 'border-color 140ms ease, opacity 140ms ease',
},
  successBox: {
    borderRadius: 16,
    padding: '14px 16px',
    border: '1px solid rgba(90,220,140,0.24)',
    background: 'rgba(60,180,100,0.10)',
    color: '#D9FFE7',
    fontWeight: 700,
  },
  button: {
  height: 56,
  borderRadius: 18,
  border: '1px solid rgba(255,255,255,0.22)',
  background: 'linear-gradient(135deg,#FFF4C9 0%,#F7D774 20%,#DAA520 55%,#F2C94C 100%)',
  color: '#241200',
  fontWeight: 900,
  fontSize: 15,
  padding: '0 22px',
  cursor: 'pointer',

  boxShadow:
    '0 26px 60px rgba(218,165,32,0.40), 0 0 28px rgba(247,215,116,0.25), inset 0 1px 0 rgba(255,255,255,0.35)',

  transition: 'border-color 140ms ease, opacity 140ms ease',
},
  buttonDisabled: {
    opacity: 0.7,
    cursor: 'not-allowed',
  },
  shareBackdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 2000,
    background: 'rgba(5, 3, 11, 0.72)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 18,
  },
  shareModal: {
    width: '100%',
    maxWidth: 760,
    borderRadius: 28,
    border: '1px solid rgba(218,165,32,0.18)',
    background: 'linear-gradient(180deg, rgba(24,12,40,0.98) 0%, rgba(10,7,20,0.99) 100%)',
    boxShadow: '0 28px 90px rgba(0,0,0,0.42)',
    zIndex: 2001,
    overflow: 'hidden',
  },
  shareModalHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 16,
    padding: '20px 20px 14px',
    borderBottom: '1px solid rgba(255,255,255,0.05)',
  },
  shareModalTitle: {
    margin: 0,
    color: '#FFF3C4',
    fontSize: 18,
    fontWeight: 900,
    lineHeight: 1.15,
  },
  shareModalText: {
    margin: '8px 0 0',
    color: 'rgba(255,243,196,0.74)',
    fontSize: 13,
    lineHeight: 1.65,
  },
  shareCloseButton: {
    minWidth: 42,
    height: 42,
    borderRadius: 999,
    border: '1px solid rgba(218,165,32,0.16)',
    background: 'rgba(255,255,255,0.04)',
    color: '#FFF3C4',
    fontSize: 18,
    fontWeight: 900,
    cursor: 'pointer',
    flex: '0 0 auto',
  },
  shareModalBody: {
  display: 'grid',
  gap: 16,
  padding: 20,
  maxHeight: '75vh',
  overflowY: 'auto',
},
  sharePreview: {
    borderRadius: 20,
    padding: 16,
    border: '1px solid rgba(218,165,32,0.14)',
    background: 'linear-gradient(135deg, rgba(75,0,130,0.22) 0%, rgba(18,10,34,0.94) 100%)',
    display: 'grid',
    gap: 10,
  },
  sharePreviewTitle: {
    margin: 0,
    color: '#F7D774',
    fontSize: 12,
    fontWeight: 900,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  sharePreviewPair: {
  margin: 0,
  color: '#FFF3C4',
  fontSize: 22,
  fontWeight: 900,
  lineHeight: 1.1,
  textAlign: 'center',
},
  sharePreviewMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  shareVisualShell: {
  borderRadius: 24,
  padding: 16,
  border: '1px solid rgba(218,165,32,0.14)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.025) 0%, rgba(255,255,255,0.015) 100%)',
  display: 'grid',
  gap: 14,
    },
 shareVisualStage: {
  display: 'grid',
  justifyItems: 'center',
  alignItems: 'center',
  padding: '8px 0 4px',
},
shareCardFrame: {
  width: '100%',
  maxWidth: 420,
  borderRadius: 32,
  padding: 14,
  background: 'linear-gradient(180deg, rgba(32,18,52,0.96) 0%, rgba(12,8,22,0.98) 100%)',
  border: '1px solid rgba(218,165,32,0.18)',
  boxShadow: '0 24px 56px rgba(0,0,0,0.36), inset 0 1px 0 rgba(255,255,255,0.05)',
},
  shareVisualImage: {
  width: '100%',
  maxWidth: 392,
  aspectRatio: '4 / 5',
  display: 'block',
  objectFit: 'cover',
  borderRadius: 24,
  border: '1px solid rgba(218,165,32,0.12)',
  background: '#12091f',
  boxShadow: '0 18px 40px rgba(0,0,0,0.28)',
},
  shareVisualActions: {
    display: 'flex',
    gap: 10,
    flexWrap: 'wrap',
  },
  shareActionsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
    gap: 10,
  },
  shareActionsGridMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 10,
  },
  shareActionButton: {
  minHeight: 54,
  borderRadius: 16,
  border: '1px solid rgba(247,215,116,0.35)',

  background:
    'linear-gradient(135deg, rgba(255,255,255,0.10) 0%, rgba(138,43,226,0.12) 50%, rgba(247,215,116,0.10) 100%)',

  color: '#FFF3C4',
  fontWeight: 900,
  fontSize: 13,
  letterSpacing: 0.25,

  cursor: 'pointer',
  padding: '0 14px',

  boxShadow:
    '0 16px 36px rgba(0,0,0,0.32), 0 0 20px rgba(138,43,226,0.20)',

  transition: 'border-color 140ms ease, opacity 140ms ease',
},
  shareTextarea: {
    width: '100%',
    minHeight: 160,
    borderRadius: 18,
    border: '1px solid rgba(218,165,32,0.16)',
    background: 'rgba(255,255,255,0.035)',
    color: '#FFF3C4',
    padding: 14,
    fontSize: 16,
    lineHeight: 1.65,
    boxSizing: 'border-box',
    resize: 'vertical',
    outline: 'none',
  },
  subNote: {
    color: 'rgba(255,243,196,0.72)',
    fontSize: 13,
    lineHeight: 1.55,
  },
  error: {
    borderRadius: 16,
    padding: '14px 16px',
    border: '1px solid rgba(255,100,100,0.22)',
    background: 'rgba(255,70,70,0.10)',
    color: '#FFD5D5',
    fontWeight: 700,
  },
  resultCard: {
  position: 'relative',
  zIndex: 1,
  borderRadius: 34,
  padding: '28px 24px 20px',
  border: '1px solid rgba(247,215,116,0.44)',
  background:
    'linear-gradient(180deg, rgba(30,15,52,0.985) 0%, rgba(10,7,20,0.995) 100%)',
  boxShadow:
    '0 34px 110px rgba(0,0,0,0.64), 0 0 46px rgba(138,43,226,0.20), inset 0 1px 0 rgba(255,255,255,0.05)',
  overflow: 'visible',
  flexShrink: 0,
  touchAction: 'pan-y',
  WebkitOverflowScrolling: 'touch',
},
  reliability: {
    borderRadius: 20,
    padding: 18,
    border: '1px solid rgba(218,165,32,0.18)',
    background: 'linear-gradient(180deg, rgba(218,165,32,0.08) 0%, rgba(255,255,255,0.03) 100%)',
    marginBottom: 18,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
  },
  reliabilityCompact: {
    borderRadius: 16,
    padding: '11px 14px',
    border: '1px solid rgba(218,165,32,0.16)',
    background: 'linear-gradient(180deg, rgba(218,165,32,0.07) 0%, rgba(255,255,255,0.025) 100%)',
    marginBottom: 14,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.035)',
  },
  reliabilityCompactLead: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    minWidth: 0,
  },
  reliabilityCompactCheck: {
    width: 28,
    height: 28,
    borderRadius: 999,
    display: 'inline-grid',
    placeItems: 'center',
    flex: '0 0 auto',
    border: '1px solid rgba(247,215,116,0.22)',
    background: 'rgba(218,165,32,0.10)',
    color: '#F7D774',
    fontSize: 14,
    fontWeight: 900,
  },
  reliabilityCompactTitle: {
    margin: 0,
    color: '#FFF3C4',
    fontSize: 13,
    fontWeight: 900,
    lineHeight: 1.2,
  },
  reliabilityCompactMeta: {
    margin: '3px 0 0',
    color: 'rgba(255,243,196,0.66)',
    fontSize: 11,
    fontWeight: 700,
    lineHeight: 1.35,
  },
  reliabilityHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    flexWrap: 'wrap',
    marginBottom: 10,
  },
  reliabilityMeta: {
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
  },
  missingWrap: {
    marginTop: 12,
    display: 'grid',
    gap: 10,
  },
  missingItem: {
    borderRadius: 14,
    padding: 12,
    border: '1px solid rgba(255,243,196,0.10)',
    background: 'rgba(255,255,255,0.035)',
  },
  missingTitle: {
    margin: 0,
    color: '#FFF3C4',
    fontSize: 13,
    fontWeight: 900,
  },
  missingMeta: {
    margin: '6px 0 0',
    color: 'rgba(255,243,196,0.72)',
    lineHeight: 1.6,
    fontSize: 13,
  },
  sectionTitle: {
    margin: '0 0 12px',
    fontSize: 15,
    fontWeight: 900,
    color: '#FFF3C4',
  },
  scoreRow: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0,1fr) minmax(260px,0.9fr)',
    gap: 16,
    marginBottom: 16,
  },
  scoreRowMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
    marginBottom: 16,
  },
  scoreBox: {
  borderRadius: 24,
  padding: '30px 20px 16px',
  border: '1px solid rgba(218,165,32,0.18)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.022) 100%)',
  boxShadow: '0 14px 34px rgba(0,0,0,0.26), inset 0 1px 0 rgba(255,255,255,0.04)',
},
  scoreValue: {
    margin: '8px 0 0',
    fontSize: 'clamp(36px, 6vw, 56px)',
    lineHeight: 0.95,
    fontWeight: 900,
    color: '#F7D774',
  },
  scoreLabel: {
    margin: 0,
    color: 'rgba(255,243,196,0.72)',
    fontWeight: 800,
    fontSize: 12,
    letterSpacing: 0.35,
    textTransform: 'uppercase',
  },
  primaryPairRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    flexWrap: 'wrap',
    textAlign: 'center',
  },
  primaryPairName: {
    color: '#F7D774',
    fontSize: 13,
    fontWeight: 900,
    lineHeight: 1.3,
  },
  primaryPairDivider: {
    color: '#D9C7FF',
    fontSize: 12,
    lineHeight: 1,
  },
  primaryRelationshipLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 30,
    padding: '0 12px',
    borderRadius: 999,
    border: '1px solid rgba(247,215,116,0.16)',
    background: 'rgba(218,165,32,0.08)',
    color: '#FFF3C4',
    fontSize: 12,
    fontWeight: 900,
    textAlign: 'center',
  },
  primarySummaryPills: {
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    flexWrap: 'wrap',
  },
  primarySummaryPill: {
    display: 'inline-flex',
    alignItems: 'center',
    minHeight: 30,
    padding: '0 11px',
    borderRadius: 999,
    border: '1px solid rgba(255,255,255,0.08)',
    background: 'rgba(255,255,255,0.035)',
    color: 'rgba(255,243,196,0.82)',
    fontSize: 11,
    fontWeight: 800,
    lineHeight: 1.3,
    textAlign: 'center',
  },
  scoreSubgrid: {
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0,1fr))',
  gap: 10,
  marginTop: 10,
},
  scoreSubgridMobile: {
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 10,
  marginTop: 10,
},
  scoreMiniCard: {
  borderRadius: 16,
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04), 0 10px 22px rgba(0,0,0,0.12)',
  padding: 13,
  border: '1px solid rgba(218,165,32,0.14)',
  background: 'rgba(255,255,255,0.03)',
},
  scoreMiniValue: {
    margin: '4px 0 0',
    color: '#F7D774',
    fontSize: 18,
    fontWeight: 900,
  },
  overviewCard: {
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 26,
  padding: '22px 20px 18px',
  border: '1px solid rgba(247,215,116,0.22)',
  background: 'linear-gradient(135deg, rgba(75,0,130,0.24) 0%, rgba(16,10,28,0.96) 56%, rgba(218,165,32,0.08) 100%)',
  boxShadow: '0 18px 46px rgba(0,0,0,0.26), 0 0 22px rgba(138,43,226,0.10), inset 0 1px 0 rgba(255,255,255,0.05)',
  display: 'grid',
  gap: 14,
},
overviewGlowA: {
  position: 'absolute',
  top: -36,
  left: -30,
  width: 150,
  height: 150,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(138,43,226,0.18) 0%, rgba(138,43,226,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
overviewGlowB: {
  position: 'absolute',
  right: -34,
  bottom: -40,
  width: 180,
  height: 180,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(247,215,116,0.14) 0%, rgba(247,215,116,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
overviewHeader: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gap: 10,
},
overviewTitle: {
  margin: 0,
  color: '#FFF3C4',
  fontSize: 18,
  fontWeight: 900,
  lineHeight: 1.15,
  textShadow: '0 0 12px rgba(247,215,116,0.12)',
},
overviewSignRow: {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  alignItems: 'center',
},
overviewSignPill: {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 28,
  padding: '0 12px',
  borderRadius: 999,
  border: '1px solid rgba(247,215,116,0.16)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.04) 100%)',
  color: '#FFF3C4',
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: 0.3,
},
overviewNarrative: {
  position: 'relative',
  zIndex: 1,
  margin: 0,
  color: 'rgba(255,243,196,0.88)',
  fontSize: 14,
  lineHeight: 1.8,
  whiteSpace: 'pre-wrap',
},
overviewNarrativeName: {
  color: '#F7D774',
  fontWeight: 900,
  textShadow: '0 0 10px rgba(247,215,116,0.12)',
},
overlayTokenHighlight: {
  color: '#F7D774',
  fontWeight: 900,
  textShadow: '0 0 10px rgba(247,215,116,0.12)',
},
relationshipGuidanceCard: {
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 28,
  padding: 20,
  marginBottom: 16,
  border: '1px solid rgba(247,215,116,0.24)',
  background: 'linear-gradient(135deg, rgba(75,0,130,0.24) 0%, rgba(16,10,28,0.97) 54%, rgba(218,165,32,0.08) 100%)',
  boxShadow: '0 20px 54px rgba(0,0,0,0.30), 0 0 24px rgba(138,43,226,0.10), inset 0 1px 0 rgba(255,255,255,0.04)',
},
relationshipGuidanceGlowA: {
  position: 'absolute',
  top: -52,
  left: -42,
  width: 180,
  height: 180,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(138,43,226,0.16) 0%, rgba(138,43,226,0) 72%)',
  pointerEvents: 'none',
},
relationshipGuidanceGlowB: {
  position: 'absolute',
  right: -56,
  bottom: -64,
  width: 210,
  height: 210,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(247,215,116,0.12) 0%, rgba(247,215,116,0) 72%)',
  pointerEvents: 'none',
},
relationshipGuidanceHeader: {
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: 12,
  flexWrap: 'wrap',
  marginBottom: 16,
},
relationshipGuidanceEyebrow: {
  margin: 0,
  color: '#F7D774',
  fontSize: 11,
  fontWeight: 900,
  letterSpacing: 0.45,
  textTransform: 'uppercase',
},
relationshipGuidanceTitle: {
  margin: '6px 0 0',
  color: '#FFF3C4',
  fontSize: 19,
  fontWeight: 900,
  lineHeight: 1.2,
},
relationshipGuidanceGrid: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: 12,
},
relationshipGuidanceGridMobile: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 10,
},
relationshipGuidanceSection: {
  borderRadius: 20,
  padding: 14,
  border: '1px solid rgba(255,255,255,0.07)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.045) 0%, rgba(255,255,255,0.022) 100%)',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.035)',
},
relationshipGuidanceSectionHeader: {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 10,
},
relationshipGuidanceSectionIcon: {
  width: 26,
  height: 26,
  borderRadius: 999,
  display: 'inline-grid',
  placeItems: 'center',
  flex: '0 0 auto',
  border: '1px solid rgba(247,215,116,0.16)',
  background: 'rgba(218,165,32,0.08)',
  color: '#F7D774',
  fontSize: 12,
  fontWeight: 900,
},
relationshipGuidanceSectionTitle: {
  margin: 0,
  color: '#FFF3C4',
  fontSize: 13,
  fontWeight: 900,
  lineHeight: 1.2,
},
relationshipGuidanceList: {
  display: 'grid',
  gap: 8,
},
relationshipGuidanceItem: {
  display: 'grid',
  gridTemplateColumns: 'auto minmax(0,1fr)',
  gap: 8,
  alignItems: 'start',
},
relationshipGuidanceDot: {
  width: 5,
  height: 5,
  borderRadius: 999,
  marginTop: 7,
  background: '#F7D774',
  boxShadow: '0 0 8px rgba(247,215,116,0.22)',
},
relationshipGuidanceText: {
  margin: 0,
  color: 'rgba(255,243,196,0.80)',
  fontSize: 12,
  lineHeight: 1.55,
},

integrationHero: {
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 28,
  padding: 22,
  border: '1px solid rgba(247,215,116,0.28)',
  background: 'linear-gradient(135deg, rgba(75,0,130,0.30) 0%, rgba(22,12,40,0.95) 55%, rgba(218,165,32,0.12) 100%)',
  boxShadow: '0 24px 70px rgba(0,0,0,0.34), 0 0 28px rgba(138,43,226,0.14), inset 0 1px 0 rgba(255,255,255,0.05)',
  display: 'grid',
  gap: 16,
},
integrationGlowA: {
  position: 'absolute',
  inset: '-40px auto auto -46px',
  width: 180,
  height: 180,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(138,43,226,0.24) 0%, rgba(138,43,226,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
integrationGlowB: {
  position: 'absolute',
  inset: 'auto -54px -54px auto',
  width: 220,
  height: 220,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(247,215,116,0.20) 0%, rgba(247,215,116,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
integrationHeader: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gap: 8,
},
integrationEyebrow: {
  margin: 0,
  color: '#F7D774',
  fontSize: 11,
  fontWeight: 900,
  letterSpacing: 0.55,
  textTransform: 'uppercase',
},
integrationTitle: {
  margin: 0,
  color: '#FFF3C4',
  fontSize: 22,
  fontWeight: 900,
  lineHeight: 1.15,
  textShadow: '0 0 16px rgba(247,215,116,0.16)',
},
integrationText: {
  margin: 0,
  color: 'rgba(255,243,196,0.88)',
  fontSize: 14,
  lineHeight: 1.8,
},
integrationPillRow: {
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexWrap: 'wrap',
  gap: 10,
},
integrationPill: {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 34,
  padding: '0 14px',
  borderRadius: 999,
  border: '1px solid rgba(247,215,116,0.20)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.04) 100%)',
  color: '#FFF3C4',
  fontSize: 12,
  fontWeight: 800,
  letterSpacing: 0.3,
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05)',
},
scoreGaugeWrap: {
  display: 'grid',
  justifyItems: 'center',
  margin: '12px 0 0',
},
  scoreGaugeRing: {
    width: 182,
    height: 182,
    borderRadius: '50%',
    display: 'grid',
    placeItems: 'center',
    border: '1px solid rgba(247,215,116,0.50)',
    background:
      'radial-gradient(circle at 50% 40%, rgba(255,255,255,0.16) 0%, rgba(255,255,255,0.04) 54%, rgba(255,255,255,0.01) 100%)',
    boxShadow:
      '0 0 40px rgba(247,215,116,0.30), 0 0 78px rgba(138,43,226,0.24)',
    position: 'relative',
    overflow: 'hidden',
  },
  scoreGaugeInner: {
    width: 136,
    height: 136,
    borderRadius: '50%',
    display: 'grid',
    alignContent: 'center',
    justifyItems: 'center',
    background: 'radial-gradient(circle, rgba(20,11,38,0.99) 0%, rgba(10,7,20,0.99) 100%)',
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.05)',
    position: 'relative',
    zIndex: 1,
  },
scoreGaugeLabel: {
  margin: 0,
  color: 'rgba(255,243,196,0.72)',
  fontSize: 10,
  fontWeight: 900,
  letterSpacing: 0.55,
  textTransform: 'uppercase',
},
scoreGaugeValue: {
  margin: '4px 0 0',
  color: '#F7D774',
  fontSize: 34,
  lineHeight: 0.95,
  fontWeight: 900,
},
  chartGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0,1fr))',
    gap: 16,
    marginBottom: 16,
  },
  chartGridMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
    marginBottom: 16,
  },
  chartCard: {
    borderRadius: 24,
    padding: 18,
    border: '1px solid rgba(247,215,116,0.28)',
    background:
      'linear-gradient(180deg, rgba(255,255,255,0.055) 0%, rgba(255,255,255,0.02) 100%)',
    boxShadow:
      '0 16px 42px rgba(0,0,0,0.34), inset 0 1px 0 rgba(255,255,255,0.05)',
  },
  planetRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '8px 0',
    borderBottom: '1px solid rgba(255,255,255,0.05)',
    color: '#FFF3C4',
    fontSize: 14,
  },
  planetLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    minWidth: 0,
  },
  planetName: {
    color: '#FFF3C4',
    fontSize: 14,
    fontWeight: 800,
  },
  planetMeta: {
    color: 'rgba(255,243,196,0.58)',
    fontSize: 11,
    lineHeight: 1.4,
  },
  planetRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 2,
    minWidth: 90,
  },
  planetValue: {
    color: '#FFF3C4',
    fontSize: 13,
    fontWeight: 800,
    textAlign: 'right',
  },
  planetSubValue: {
    color: 'rgba(255,243,196,0.62)',
    fontSize: 11,
    textAlign: 'right',
  },
  dimGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0,1fr))',
    gap: 16,
  },
  dimGridMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
  },
  dimCard: {
    position: 'relative',
    overflow: 'hidden',
    borderRadius: 24,
    padding: 18,
    border: '1px solid rgba(247,215,116,0.22)',
    background: 'linear-gradient(135deg, rgba(75,0,130,0.24) 0%, rgba(16,10,28,0.96) 56%, rgba(218,165,32,0.08) 100%)',
    boxShadow: '0 16px 40px rgba(0,0,0,0.24), 0 0 18px rgba(138,43,226,0.08), inset 0 1px 0 rgba(255,255,255,0.05)',
    display: 'grid',
    gap: 12,
    minHeight: 0,
    maxHeight: 'none',
    touchAction: 'pan-y',
    overscrollBehaviorY: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  dimHeader: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    marginBottom: 0,
  },
  dimMeta: {
    position: 'relative',
    zIndex: 1,
    display: 'flex',
    gap: 8,
    flexWrap: 'wrap',
    marginBottom: 0,
  },
  aspectList: {
    position: 'relative',
    zIndex: 1,
    margin: '2px 0 0',
    paddingLeft: 18,
    color: 'rgba(255,243,196,0.84)',
    lineHeight: 1.65,
    fontSize: 13,
  },
  dimBar: {
    position: 'relative',
    zIndex: 1,
    height: 12,
    borderRadius: 999,
    background: 'rgba(255,255,255,0.07)',
    overflow: 'hidden',
    border: '1px solid rgba(255,255,255,0.05)',
    marginBottom: 0,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
  },
  dimFill: {
    height: '100%',
    borderRadius: 999,
    background: 'linear-gradient(90deg, #4B0082 0%, #8A2BE2 32%, #DAA520 100%)',
    boxShadow: '0 0 18px rgba(218,165,32,0.18)',
  },
  dimGlowA: {
    position: 'absolute',
    top: -28,
    left: -24,
    width: 120,
    height: 120,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(138,43,226,0.16) 0%, rgba(138,43,226,0) 72%)',
    filter: 'none',
    pointerEvents: 'none',
  },
  dimGlowB: {
    position: 'absolute',
    right: -30,
    bottom: -34,
    width: 150,
    height: 150,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(247,215,116,0.12) 0%, rgba(247,215,116,0) 72%)',
    filter: 'none',
    pointerEvents: 'none',
  },
  dimScore: {
    color: '#F7D774',
    fontSize: 24,
    fontWeight: 900,
    lineHeight: 1,
    textShadow: '0 0 12px rgba(247,215,116,0.14)',
  },
  dimInterpretation: {
    position: 'relative',
    zIndex: 1,
    margin: 0,
    color: 'rgba(255,243,196,0.84)',
    fontSize: 13,
    lineHeight: 1.7,
  },
  text: {
    margin: 0,
    color: 'rgba(255,243,196,0.85)',
    lineHeight: 1.7,
    fontSize: 14,
  },
  list: {
    margin: 0,
    paddingLeft: 18,
    color: 'rgba(255,243,196,0.85)',
    lineHeight: 1.7,
    fontSize: 14,
  },
  aspectsCard: {
    borderRadius: 24,
    padding: 18,
    border: '1px solid rgba(218,165,32,0.16)',
    background: 'linear-gradient(180deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.022) 100%)',
    marginBottom: 18,
    boxShadow: '0 16px 42px rgba(0,0,0,0.28), inset 0 1px 0 rgba(255,255,255,0.04)',
  },
  aspectItem: {
    borderRadius: 16,
    padding: 12,
    border: '1px solid rgba(255,255,255,0.06)',
    background: 'rgba(255,255,255,0.024)',
  },
  aspectItemTitle: {
    margin: 0,
    color: '#FFF3C4',
    fontWeight: 800,
    fontSize: 13,
    lineHeight: 1.5,
  },
  aspectItemMeta: {
    margin: '6px 0 0',
    color: 'rgba(255,243,196,0.64)',
    fontSize: 12,
    lineHeight: 1.5,
  },
  dominantAspectsCard: {
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 28,
  padding: '22px 20px 18px',
  border: '1px solid rgba(247,215,116,0.24)',
  background: 'linear-gradient(135deg, rgba(75,0,130,0.24) 0%, rgba(16,10,28,0.96) 56%, rgba(218,165,32,0.10) 100%)',
  boxShadow: '0 18px 46px rgba(0,0,0,0.26), 0 0 22px rgba(138,43,226,0.10), inset 0 1px 0 rgba(255,255,255,0.05)',
  display: 'grid',
  gap: 14,
},
dominantAspectsGlowA: {
  position: 'absolute',
  top: -36,
  left: -30,
  width: 150,
  height: 150,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(138,43,226,0.18) 0%, rgba(138,43,226,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
dominantAspectsGlowB: {
  position: 'absolute',
  right: -34,
  bottom: -40,
  width: 180,
  height: 180,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(247,215,116,0.14) 0%, rgba(247,215,116,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
dominantAspectsHeader: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gap: 10,
},
dominantAspectsTitle: {
  margin: 0,
  color: '#FFF3C4',
  fontSize: 18,
  fontWeight: 900,
  lineHeight: 1.15,
  textShadow: '0 0 12px rgba(247,215,116,0.12)',
},
dominantAspectsMetaRow: {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  alignItems: 'center',
},
dominantAspectsBody: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gridTemplateColumns: 'repeat(2, minmax(0,1fr))',
  gap: 12,
  alignItems: 'start',
  },
dominantAspectsBodyMobile: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: 12,
},
dominantAspectPremiumItem: {
  borderRadius: 18,
  padding: '13px 13px 12px',
  border: '1px solid rgba(255,255,255,0.08)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.055) 0%, rgba(255,255,255,0.025) 100%)',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
  display: 'grid',
  gap: 6,
  alignContent: 'start',
},
dominantAspectPremiumTop: {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
},
dominantAspectPremiumDot: {
  width: 8,
  height: 8,
  borderRadius: '50%',
  background: '#F7D774',
  boxShadow: '0 0 12px rgba(247,215,116,0.30)',
  flex: '0 0 auto',
},
dominantAspectPremiumTitle: {
  margin: 0,
  color: '#FFF3C4',
  fontWeight: 900,
  fontSize: 13,
  lineHeight: 1.55,
},
dominantAspectPremiumMeta: {
  margin: 0,
  color: 'rgba(255,243,196,0.76)',
  fontSize: 12,
  lineHeight: 1.6,
},
  stackedCards: {
    display: 'grid',
    gap: 16,
    width: '100%',
  },
  highlightGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
    gap: 12,
  },
  highlightGridMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 12,
  },
  highlightItem: {
    borderRadius: 18,
    padding: 16,
    border: '1px solid rgba(218,165,32,0.14)',
    background: 'rgba(255,255,255,0.03)',
    display: 'grid',
    gap: 8,
    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
  },
  highlightTitle: {
    margin: 0,
    color: '#FFF3C4',
    fontWeight: 900,
    fontSize: 13,
    lineHeight: 1.5,
  },
  highlightMeta: {
    margin: 0,
    color: 'rgba(255,243,196,0.66)',
    fontSize: 12,
    lineHeight: 1.55,
  },
  overlayHighlightsCard: {
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 26,
  padding: '22px 20px 18px',
  border: '1px solid rgba(247,215,116,0.22)',
  background: 'linear-gradient(135deg, rgba(75,0,130,0.24) 0%, rgba(16,10,28,0.96) 56%, rgba(218,165,32,0.10) 100%)',
  boxShadow: '0 18px 46px rgba(0,0,0,0.26), 0 0 22px rgba(138,43,226,0.10), inset 0 1px 0 rgba(255,255,255,0.05)',
  display: 'grid',
  gap: 14,
},
overlayHighlightsGlowA: {
  position: 'absolute',
  top: -36,
  left: -30,
  width: 150,
  height: 150,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(138,43,226,0.18) 0%, rgba(138,43,226,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
overlayHighlightsGlowB: {
  position: 'absolute',
  right: -34,
  bottom: -40,
  width: 180,
  height: 180,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(247,215,116,0.14) 0%, rgba(247,215,116,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
overlayHighlightsHeader: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gap: 10,
},
overlayHighlightsTitle: {
  margin: 0,
  color: '#FFF3C4',
  fontSize: 18,
  fontWeight: 900,
  lineHeight: 1.15,
  textShadow: '0 0 12px rgba(247,215,116,0.12)',
},
overlayHighlightsMetaRow: {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  alignItems: 'center',
},
overlayHighlightsBody: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gap: 12,
},
overlayHighlightsItem: {
  borderRadius: 18,
  padding: '14px 14px 13px',
  border: '1px solid rgba(255,255,255,0.08)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.055) 0%, rgba(255,255,255,0.025) 100%)',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
  display: 'grid',
  gap: 8,
},
overlayHighlightsItemTop: {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
},
overlayHighlightsDot: {
  width: 8,
  height: 8,
  borderRadius: '50%',
  background: '#F7D774',
  boxShadow: '0 0 12px rgba(247,215,116,0.30)',
  flex: '0 0 auto',
},
overlayHighlightsItemTitle: {
  margin: 0,
  color: '#FFF3C4',
  fontWeight: 900,
  fontSize: 13,
  lineHeight: 1.55,
},
overlayHighlightsItemText: {
  margin: 0,
  color: 'rgba(255,243,196,0.78)',
  fontSize: 13,
  lineHeight: 1.7,
},
  overlayColumns: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0,1fr))',
    gap: 16,
  },
  overlayColumnsMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
  },
  overlayList: {
    display: 'grid',
    gap: 12,
  },
  overlayItem: {
    borderRadius: 16,
    padding: 12,
    border: '1px solid rgba(255,255,255,0.06)',
    background: 'rgba(255,255,255,0.024)',
    display: 'grid',
    gap: 6,
  },
  overlayItemTitle: {
    margin: 0,
    color: '#FFF3C4',
    fontWeight: 800,
    fontSize: 13,
    lineHeight: 1.5,
  },
  overlayItemMeta: {
    margin: 0,
    color: 'rgba(255,243,196,0.64)',
    fontSize: 12,
    lineHeight: 1.55,
  },
  triGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0,1fr))',
    gap: 16,
  },
  triGridMobile: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 16,
  },
  insightPanelCard: {
  position: 'relative',
  overflow: 'hidden',
  borderRadius: 24,
  padding: '20px 18px 16px',
  border: '1px solid rgba(247,215,116,0.22)',
  background: 'linear-gradient(135deg, rgba(75,0,130,0.22) 0%, rgba(16,10,28,0.96) 56%, rgba(218,165,32,0.08) 100%)',
  boxShadow: '0 18px 42px rgba(0,0,0,0.24), 0 0 20px rgba(138,43,226,0.10), inset 0 1px 0 rgba(255,255,255,0.05)',
  display: 'grid',
  gap: 12,
  alignContent: 'start',
},
insightPanelGlowA: {
  position: 'absolute',
  top: -32,
  left: -26,
  width: 130,
  height: 130,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(138,43,226,0.16) 0%, rgba(138,43,226,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
insightPanelGlowB: {
  position: 'absolute',
  right: -30,
  bottom: -34,
  width: 150,
  height: 150,
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(247,215,116,0.12) 0%, rgba(247,215,116,0) 72%)',
  filter: 'none',
  pointerEvents: 'none',
},
insightPanelHeader: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gap: 8,
},
insightPanelTitle: {
  margin: 0,
  color: '#FFF3C4',
  fontSize: 18,
  fontWeight: 900,
  lineHeight: 1.15,
  textShadow: '0 0 12px rgba(247,215,116,0.12)',
},
insightPanelBadge: {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content',
  minHeight: 28,
  padding: '0 12px',
  borderRadius: 999,
  border: '1px solid rgba(247,215,116,0.18)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.04) 100%)',
  color: '#FFF3C4',
  fontSize: 11,
  fontWeight: 900,
  letterSpacing: 0.35,
  textTransform: 'uppercase',
},
insightPanelBody: {
  position: 'relative',
  zIndex: 1,
  display: 'grid',
  gap: 10,
},
insightPanelItem: {
  borderRadius: 16,
  padding: '12px 12px 11px',
  border: '1px solid rgba(255,255,255,0.08)',
  background: 'linear-gradient(180deg, rgba(255,255,255,0.055) 0%, rgba(255,255,255,0.025) 100%)',
  boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.04)',
  display: 'grid',
  gap: 8,
},
insightPanelItemTop: {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 8,
},
insightPanelDot: {
  width: 8,
  height: 8,
  borderRadius: '50%',
  background: '#F7D774',
  boxShadow: '0 0 12px rgba(247,215,116,0.30)',
  flex: '0 0 auto',
  marginTop: 6,
},
insightPanelText: {
  margin: 0,
  color: 'rgba(255,243,196,0.84)',
  fontSize: 13,
  lineHeight: 1.7,
},
};

const PLANET_ORDER = ['sun', 'moon', 'mercury', 'venus', 'mars', 'jupiter', 'saturn', 'northNode', 'ascendant'];
const PLANET_LABELS = {
  sun: 'Sol',
  moon: 'Luna',
  mercury: 'Mercurio',
  venus: 'Venus',
  mars: 'Marte',
  jupiter: 'Júpiter',
  saturn: 'Saturno',
  northNode: 'Nodo Norte',
  ascendant: 'Ascendente',
};
const DIMENSION_LABELS = {
  emotional: 'Resonancia Emocional',
  communication: 'Comunicación',
  attraction: 'Atracción & Química',
  stability: 'Estabilidad',
  karmic: 'Eje Kármico',
};
const OVERLAY_DIMENSION_LABELS = {
  emotional: 'Cruces emocionales',
  communication: 'Cruces comunicacionales',
  attraction: 'Cruces de atracción',
  stability: 'Cruces de estabilidad',
  karmic: 'Cruces kármicos',
};
const PLANET_LABELS_EN = { sun: 'Sun', moon: 'Moon', mercury: 'Mercury', venus: 'Venus', mars: 'Mars', jupiter: 'Jupiter', saturn: 'Saturn', northNode: 'North Node', ascendant: 'Ascendant' };
const DIMENSION_LABELS_EN = { emotional: 'Emotional Resonance', communication: 'Communication', attraction: 'Attraction & Chemistry', stability: 'Stability', karmic: 'Karmic Axis' };
const OVERLAY_DIMENSION_LABELS_EN = { emotional: 'Emotional overlays', communication: 'Communication overlays', attraction: 'Attraction overlays', stability: 'Stability overlays', karmic: 'Karmic overlays' };
const presentationLabel = (spanishCatalog, englishCatalog, key) => (isEnglishPresentation() ? englishCatalog : spanishCatalog)[key] || key;

const ASPECT_LOCALIZE_MAP = {
  sun: 'Sol',
  moon: 'Luna',
  mercury: 'Mercurio',
  venus: 'Venus',
  mars: 'Marte',
  jupiter: 'Júpiter',
  saturn: 'Saturno',
  uranus: 'Urano',
  neptune: 'Neptuno',
  pluto: 'Plutón',
  ascendant: 'Ascendente',
  descendant: 'Descendente',
  northnode: 'Nodo Norte',
  southnode: 'Nodo Sur',
  conjunction: 'conjunción',
  trine: 'trígono',
  sextile: 'sextil',
  square: 'cuadratura',
  opposition: 'oposición',
  quincunx: 'quincuncio',
  inconjunct: 'quincuncio',
};

const ASPECT_LOCALIZE_PATTERN = new RegExp(
  `\\b(${Object.keys(ASPECT_LOCALIZE_MAP).sort((a, b) => b.length - a.length).join('|')})\\b`,
  'gi'
);

const NARRATIVE_LOCALIZE_MAP = {
  aries: 'Aries',
  taurus: 'Tauro',
  gemini: 'Géminis',
  cancer: 'Cáncer',
  leo: 'Leo',
  virgo: 'Virgo',
  libra: 'Libra',
  scorpio: 'Escorpio',
  sagittarius: 'Sagitario',
  capricorn: 'Capricornio',
  aquarius: 'Acuario',
  pisces: 'Piscis',
  and: 'y',
  conjunction: 'conjunción',
  trine: 'trígono',
  sextile: 'sextil',
  square: 'cuadratura',
  opposition: 'oposición',
  ascendant: 'Ascendente',
  northnode: 'Nodo Norte',
  sun: 'Sol',
  moon: 'Luna',
  mercury: 'Mercurio',
  venus: 'Venus',
  mars: 'Marte',
  jupiter: 'Júpiter',
  saturn: 'Saturno',
};

const NARRATIVE_LOCALIZE_ENTRIES = Object.entries(NARRATIVE_LOCALIZE_MAP).sort(
  ([a], [b]) => b.length - a.length
);

function parseOptionalFiniteNumber(value) {
  if (value === '' || value == null) return undefined;
  const num = Number(value);
  return Number.isFinite(num) ? num : null;
}

function hasUsableLatLng(lat, lng) {
  const latNum = Number(lat);
  const lngNum = Number(lng);
  if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return false;
  if (latNum === 0 && lngNum === 0) return false;
  return true;
}

function readSavedSynastriesFromStorage() {
  clearLegacySavedSynastryStorage();
  return [];
}

function unwrapSavedSynastryItem(item) {
  if (!item || typeof item !== 'object') return item;
  return item?.saved || item?.item || item;
}

function mergeSavedSynastriesByIdentity(items) {
  const list = Array.isArray(items) ? items : [];
  const seen = new Map();

  list.forEach((rawItem) => {
    const item = unwrapSavedSynastryItem(rawItem);
    if (!item || typeof item !== 'object') return;

    const itemId = String(item?.id || item?._id || '').trim();
    const itemFingerprint = String(item?.fingerprint || '').trim();
    const aName = String(item?.personA?.nickname || item?.personA?.name || '').trim().toLowerCase();
    const bName = String(item?.personB?.nickname || item?.personB?.name || '').trim().toLowerCase();
    const aDate = String(item?.personA?.birthDate || '').trim();
    const bDate = String(item?.personB?.birthDate || '').trim();
    const score = String(
      item?.compatibilityScore ||
      item?.compatibility ||
      item?.result?.compatibility?.masterScore ||
      item?.resultSnapshot?.compatibility?.masterScore ||
      ''
    ).trim();

    const identityKey = itemId || itemFingerprint || `${aName}::${aDate}::${bName}::${bDate}::${score}`;
    if (!identityKey) return;

    const previous = seen.get(identityKey);
    if (!previous) {
      seen.set(identityKey, item);
      return;
    }

    const previousHasResult = Boolean(
      previous?.result ||
      previous?.reading ||
      previous?.analysis ||
      previous?.synastry ||
      previous?.resultSnapshot
    );
    const nextHasResult = Boolean(
      item?.result ||
      item?.reading ||
      item?.analysis ||
      item?.synastry ||
      item?.resultSnapshot
    );

    if (!previousHasResult && nextHasResult) {
      seen.set(identityKey, item);
    }
  });

  return Array.from(seen.values());
}

function emptyPerson() {
  return {
    nickname: '',
    birthDate: '',
    hasTime: false,
    birthTime: '',
    birthCity: '',
    birthCountry: '',
    birthPlaceLabel: '',
    lat: '',
    lng: '',
    timezoneOffsetMinutes: '',
    birthTimezone: '',
  };
}
function normalizeSavedPerson(savedPerson, fallbackName) {
  const hasCoordinates = hasUsableLatLng(savedPerson?.lat, savedPerson?.lng);
  const hasTimezone = Number.isFinite(Number(savedPerson?.timezoneOffsetMinutes));

  const hasAnyTimeData = Boolean(
    savedPerson?.birthTime ||
      savedPerson?.birthCity ||
      savedPerson?.birthCountry ||
      savedPerson?.birthPlaceLabel ||
      hasCoordinates ||
      hasTimezone
  );

  return {
    ...emptyPerson(),
    nickname: savedPerson?.nickname || savedPerson?.name || fallbackName,
    birthDate: savedPerson?.birthDate || '',
    hasTime: hasAnyTimeData,
    birthTime: savedPerson?.birthTime || '',
    birthCity: savedPerson?.birthCity || '',
    birthCountry: savedPerson?.birthCountry || '',
    birthPlaceLabel: savedPerson?.birthPlaceLabel || '',
    lat: hasCoordinates ? savedPerson?.lat ?? '' : '',
    lng: hasCoordinates ? savedPerson?.lng ?? '' : '',
    timezoneOffsetMinutes: hasTimezone ? savedPerson?.timezoneOffsetMinutes ?? '' : '',
    birthTimezone: typeof savedPerson?.birthTimezone === 'string' ? savedPerson.birthTimezone : '',
  };
}

function getSavedResultPayload(savedReading) {
  return (
    savedReading?.result ||
    savedReading?.resultSnapshot ||
    savedReading?.reading ||
    savedReading?.analysis ||
    savedReading?.synastry ||
    savedReading?.payload ||
    savedReading?.raw?.resultSnapshot ||
    savedReading?.raw?.result ||
    savedReading?.raw?.reading ||
    null
  );
}

function isGenericPersonLabel(value) {
  const normalized = String(value || '').trim().toLowerCase();
  return (
    !normalized ||
    normalized === 'persona a' ||
    normalized === 'persona b' ||
    normalized === 'persona' ||
    normalized === 'person a' ||
    normalized === 'person b'
  );
}

function getBestExplicitName(person, metadataPerson, fallback) {
  const candidates = [
    person?.nickname,
    metadataPerson?.nickname,
    person?.name,
    metadataPerson?.name,
  ];

  for (const candidate of candidates) {
    const clean = String(candidate || '').trim();
    if (!clean) continue;
    if (isGenericPersonLabel(clean)) continue;
    return clean;
  }

  return fallback;
}
function isLikelyNativeShareDevice() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  const hasNativeShare = typeof navigator.share === 'function';
  if (!hasNativeShare) return false;

  const touchPoints = Number(navigator.maxTouchPoints || 0);
  const coarsePointer = typeof window.matchMedia === 'function'
    ? window.matchMedia('(pointer: coarse)').matches
    : false;
  const mobileWidth = Number(window.innerWidth || 0) <= 1024;

  return touchPoints > 0 || coarsePointer || mobileWidth;
}

function buildSharePayload(result, personA, personB) {
  const compatibility = Number(result?.compatibility?.masterScore || 0);
  const attraction = Number(result?.dimensions?.attraction?.score || 0);
  const emotional = Number(result?.dimensions?.emotional?.score || 0);
  const stability = Number(result?.dimensions?.stability?.score || 0);
  const karmic = Number(result?.dimensions?.karmic?.score || 0);
  const metaA = result?.metadata?.personA || {};
  const metaB = result?.metadata?.personB || {};
  const explicitNameA = getBestExplicitName(personA, metaA, 'Persona A');
const explicitNameB = getBestExplicitName(personB, metaB, 'Persona B');

const shareNameA = explicitNameA;
const shareNameB = explicitNameB;

const signA = String(metaA?.sunSign || personA?.sunSign || personA?.sign || '').trim();
const signB = String(metaB?.sunSign || personB?.sunSign || personB?.sign || '').trim();

const identityA = signA ? `${shareNameA} · ${signA}` : shareNameA;
const identityB = signB ? `${shareNameB} · ${signB}` : shareNameB;
const pairLabel = `${identityA} ✦ ${identityB}`;
  const appUrl = typeof window !== 'undefined'
    ? (window.location.hostname === 'localhost' ? 'https://zodiacus.app' : window.location.origin)
    : 'https://zodiacus.app';

  const profile = getRelationshipProfile(compatibility);

const shareText = [
  '✨ Compatibilidad Zodiacus',
  '',
  pairLabel,
  '',
  `Compatibilidad sinástrica: ${compatibility}%`,
  attraction ? `Atracción: ${attraction}%` : '',
  emotional ? `Resonancia emocional: ${emotional}%` : '',
  stability ? `Estabilidad: ${stability}%` : '',
  karmic ? `Eje kármico: ${karmic}%` : '',
  '',
  `Tipo de vínculo: ${profile.label}`,
  ...profile.bullets.map((b) => `• ${b}`),
  '',
  'Descubrí tu compatibilidad cósmica en Zodiacus ✨',
  appUrl,
].filter(Boolean).join('\n');

  const encodedText = encodeURIComponent(shareText);
  const encodedUrl = encodeURIComponent(appUrl);
  const encodedPair = encodeURIComponent(`Compatibilidad Zodiacus · ${pairLabel}`);

  return {
    compatibility,
    attraction,
    emotional,
    stability,
    karmic,
    pairLabel,
    shareNameA,
shareNameB,
signA,
signB,
identityA,
identityB,
explicitNameA,
explicitNameB,
    appUrl,
    shareText,
    whatsappUrl: `https://wa.me/?text=${encodedText}`,
    telegramUrl: `https://t.me/share/url?url=${encodedUrl}&text=${encodedPair}`,
    facebookUrl: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    twitterUrl: `https://twitter.com/intent/tweet?text=${encodedPair}&url=${encodedUrl}`,
  };
}

function escapeSvgText(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function buildShareCardSvg(payload) {
  const identityA = escapeSvgText(payload?.identityA || 'Persona A');
  const identityB = escapeSvgText(payload?.identityB || 'Persona B');
  const compatibility = Number(payload?.compatibility || 0);
  const attraction = Number(payload?.attraction || 0);
  const emotional = Number(payload?.emotional || 0);
  const stability = Number(payload?.stability || 0);
  const karmic = Number(payload?.karmic || 0);

  return `
<svg xmlns="http://www.w3.org/2000/svg" width="1200" height="1500" viewBox="0 0 1200 1500">
  <defs>
    <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#0e0518"/>
      <stop offset="45%" stop-color="#2b0d4a"/>
      <stop offset="100%" stop-color="#07030f"/>
    </linearGradient>
    <radialGradient id="goldAura" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="#ffd875" stop-opacity="0.55"/>
      <stop offset="58%" stop-color="#ffd875" stop-opacity="0.10"/>
      <stop offset="100%" stop-color="#ffd875" stop-opacity="0"/>
    </radialGradient>
    <radialGradient id="violetAura" cx="50%" cy="50%" r="50%">
      <stop offset="0%" stop-color="#a855f7" stop-opacity="0.38"/>
      <stop offset="58%" stop-color="#a855f7" stop-opacity="0.10"/>
      <stop offset="100%" stop-color="#a855f7" stop-opacity="0"/>
    </radialGradient>
    <linearGradient id="goldText" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#fff4cc"/>
      <stop offset="55%" stop-color="#f7d774"/>
      <stop offset="100%" stop-color="#daa520"/>
    </linearGradient>
    <linearGradient id="metricFill" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#241032"/>
      <stop offset="100%" stop-color="#3a1858"/>
    </linearGradient>
    <linearGradient id="ring" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0%" stop-color="#fff1b8"/>
      <stop offset="50%" stop-color="#f7d774"/>
      <stop offset="100%" stop-color="#9b5cff"/>
    </linearGradient>
  </defs>

  <rect width="1200" height="1500" fill="url(#bg)"/>
  <circle cx="170" cy="190" r="250" fill="url(#goldAura)"/>
  <circle cx="1010" cy="230" r="280" fill="url(#violetAura)"/>
  <circle cx="960" cy="1270" r="260" fill="url(#goldAura)"/>
  <circle cx="180" cy="1220" r="230" fill="url(#violetAura)"/>

  <rect x="72" y="72" width="1056" height="1356" rx="48" fill="rgba(255,255,255,0.035)" stroke="rgba(255,216,117,0.22)" stroke-width="2"/>

  <text x="600" y="158" text-anchor="middle" fill="#f7d774" font-size="34" font-weight="900" font-family="Arial">✦ ZODIACUS PREMIUM</text>
  <text x="600" y="228" text-anchor="middle" fill="#fff3c4" font-size="68" font-weight="900" font-family="Arial">Compatibilidad Cósmica</text>
  <text x="600" y="286" text-anchor="middle" fill="#d8c4ff" font-size="28" font-weight="700" font-family="Arial">Sinastría profunda premium</text>

  <rect x="132" y="336" width="936" height="172" rx="30" fill="rgba(255,255,255,0.04)" stroke="rgba(255,216,117,0.16)"/>
  <text x="600" y="392" text-anchor="middle" fill="#f7d774" font-size="20" font-weight="900" font-family="Arial" letter-spacing="3">PAREJA ANALIZADA</text>
  <text x="600" y="442" text-anchor="middle" fill="url(#goldText)" font-size="34" font-weight="900" font-family="Arial">${identityA}</text>
  <text x="600" y="484" text-anchor="middle" fill="url(#goldText)" font-size="34" font-weight="900" font-family="Arial">✦ ${identityB}</text>

  <g transform="translate(600 700)">
    <circle cx="0" cy="0" r="154" fill="rgba(255,255,255,0.03)" stroke="rgba(255,255,255,0.08)" stroke-width="2"/>
    <circle cx="0" cy="0" r="136" fill="none" stroke="url(#ring)" stroke-width="10"/>
    <circle cx="0" cy="0" r="122" fill="rgba(255,255,255,0.018)"/>

    <text x="0" y="-40" text-anchor="middle" fill="#fff3c4" font-size="22" font-weight="900" font-family="Arial" letter-spacing="3">COMPATIBILIDAD</text>

    <text x="0" y="36" text-anchor="middle" dominant-baseline="middle" fill="#fff3c4" font-size="96" font-weight="900" font-family="Arial">${compatibility}%</text>
  </g>

  <g transform="translate(132 930)">
    <rect x="0" y="0" width="430" height="170" rx="28" fill="url(#metricFill)" stroke="rgba(255,216,117,0.14)"/>
    <text x="34" y="58" fill="#f7d774" font-size="28" font-weight="900" font-family="Arial">Atracción</text>
    <text x="34" y="128" fill="#fff3c4" font-size="72" font-weight="900" font-family="Arial">${attraction}%</text>
  </g>
  <g transform="translate(638 930)">
    <rect x="0" y="0" width="430" height="170" rx="28" fill="url(#metricFill)" stroke="rgba(255,216,117,0.14)"/>
    <text x="34" y="58" fill="#f7d774" font-size="28" font-weight="900" font-family="Arial">Emoción</text>
    <text x="34" y="128" fill="#fff3c4" font-size="72" font-weight="900" font-family="Arial">${emotional}%</text>
  </g>
  <g transform="translate(132 1132)">
    <rect x="0" y="0" width="430" height="170" rx="28" fill="url(#metricFill)" stroke="rgba(255,216,117,0.14)"/>
    <text x="34" y="58" fill="#f7d774" font-size="28" font-weight="900" font-family="Arial">Estabilidad</text>
    <text x="34" y="128" fill="#fff3c4" font-size="72" font-weight="900" font-family="Arial">${stability}%</text>
  </g>
  <g transform="translate(638 1132)">
    <rect x="0" y="0" width="430" height="170" rx="28" fill="url(#metricFill)" stroke="rgba(255,216,117,0.14)"/>
    <text x="34" y="58" fill="#f7d774" font-size="28" font-weight="900" font-family="Arial">Kármico</text>
    <text x="34" y="128" fill="#fff3c4" font-size="72" font-weight="900" font-family="Arial">${karmic}%</text>
  </g>

  <text x="600" y="1368" text-anchor="middle" fill="#fff3c4" font-size="32" font-weight="800" font-family="Arial">Descubrí tu compatibilidad cósmica en Zodiacus</text>
  <text x="600" y="1416" text-anchor="middle" fill="#d8c4ff" font-size="24" font-weight="700" font-family="Arial">Chat, sinastría, matches y experiencias zodiacales premium</text>
</svg>`;
}

async function renderShareCardPngBlob(payload) {
  const svg = buildShareCardSvg(payload);
  const svgBlob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
  const svgUrl = URL.createObjectURL(svgBlob);

  try {
    const image = await new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = svgUrl;
    });

    const canvas = document.createElement('canvas');
    canvas.width = 1200;
    canvas.height = 1500;

    const context = canvas.getContext('2d');
    if (!context) {
      throw new Error('No se pudo inicializar el canvas de la card premium.');
    }

    context.drawImage(image, 0, 0, canvas.width, canvas.height);

    const pngBlob = await new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (blob) resolve(blob);
        else reject(new Error('No se pudo generar la imagen PNG de la card premium.'));
      }, 'image/png');
    });

    return pngBlob;
  } finally {
    URL.revokeObjectURL(svgUrl);
  }
}

async function createShareCardFile(payload) {
  const pngBlob = await renderShareCardPngBlob(payload);
  const fileName = `zodiacus-compatibilidad-${Date.now()}.png`;
  return new File([pngBlob], fileName, { type: 'image/png' });
}
function normalizeArray(value) {
  return Array.isArray(value) ? value : [];
}

function inferSavedReadingMode(item) {
  const mode = String(
    item?.mode || item?.readingType || item?.calculationMode || item?.raw?.mode || ''
  )
    .trim()
    .toLowerCase();

  if (mode === 'quick' || mode === 'deep') return mode;

  const source = String(
    item?.source || item?.sourceType || item?.raw?.source || item?.raw?.sourceType || ''
  )
    .trim()
    .toLowerCase();

  if (source.includes('quick') || source.includes('solar')) return 'quick';
  if (source.includes('deep') || source.includes('synastry')) return 'deep';

  const resultLike = item?.result || item?.reading || item?.resultSnapshot || item?.raw?.result || item?.raw?.reading || item?.raw?.resultSnapshot || item;
  const dims = resultLike?.dimensions || resultLike?.compatibility?.dimensions || {};

  const looksQuick = Boolean(
    resultLike?.pair?.signA &&
    resultLike?.pair?.signB
  ) || Boolean(
    dims && typeof dims === 'object' &&
    ('energy' in dims || 'expression' in dims || 'magnetism' in dims || 'growth' in dims)
  );

  const looksDeep = Boolean(
    resultLike?.metadata?.personA ||
    resultLike?.metadata?.personB ||
    resultLike?.charts?.personA ||
    resultLike?.charts?.personB ||
    resultLike?.houseOverlays ||
    resultLike?.significantAspects ||
    (dims && typeof dims === 'object' && ('attraction' in dims || 'emotional' in dims || 'communication' in dims || 'karmic' in dims))
  );

  if (looksQuick && !looksDeep) return 'quick';
  if (looksDeep) return 'deep';

  return 'unknown';
}

function formatPlanetValue(planet) {
  if (!planet) return '—';
  if (planet.sign == null) return 'No calculado';
  return `${planet.sign}${planet.certain === false ? ' ⚠' : ''}`;
}

function formatDegreeValue(value) {
  if (!Number.isFinite(Number(value))) return null;
  return `${Number(value).toFixed(1)}°`;
}



function localizeSynastryDisplayValue(value) {
  const raw = String(value ?? '');

  if (!isEnglishPresentation() || !raw) return raw;

  const replacements = [
    [/\bCapricornio\b/gi, 'Capricorn'],
    [/\bAcuario\b/gi, 'Aquarius'],
    [/\bPiscis\b/gi, 'Pisces'],
    [/\bAries\b/gi, 'Aries'],
    [/\bTauro\b/gi, 'Taurus'],
    [/\bGéminis\b/gi, 'Gemini'],
    [/\bGeminis\b/gi, 'Gemini'],
    [/\bCáncer\b/gi, 'Cancer'],
    [/\bCancer\b/gi, 'Cancer'],
    [/\bLeo\b/gi, 'Leo'],
    [/\bVirgo\b/gi, 'Virgo'],
    [/\bLibra\b/gi, 'Libra'],
    [/\bEscorpio\b/gi, 'Scorpio'],
    [/\bSagitario\b/gi, 'Sagittarius'],

    [/\bNo calculado\b/gi, 'Not calculated'],
    [/\bPersona A\b/gi, 'Person A'],
    [/\bPersona B\b/gi, 'Person B'],

    [/\bParcial\b/gi, 'Partial'],
    [/\bCompleta\b/gi, 'Complete'],
    [/\bCompleto\b/gi, 'Complete'],
    [/\bCasas faltantes\b/gi, 'Missing houses'],

    [/\borbe\b/gi, 'orb'],
  ];

  return replacements.reduce(
    (text, [pattern, replacement]) => text.replace(pattern, replacement),
    raw
  );
}

function localizeGenericPersonName(value) {
  return localizeSynastryDisplayValue(value);
}

function localizeDisplayedAspectText(value) {
  let text = localizeAspectText(value);

  if (!isEnglishPresentation()) return text;

  text = localizeSynastryDisplayValue(text)
    .replace(/\s+en\s+/gi, ' in ')
    .replace(/\s+con\s+orb\b/gi, ' with orb');

  const labels = {
    sun: 'Sun',
    moon: 'Moon',
    mercury: 'Mercury',
    venus: 'Venus',
    mars: 'Mars',
    jupiter: 'Jupiter',
    saturn: 'Saturn',
    uranus: 'Uranus',
    neptune: 'Neptune',
    pluto: 'Pluto',
  };

  return text.replace(
    /\b(sun|moon|mercury|venus|mars|jupiter|saturn|uranus|neptune|pluto)\b/gi,
    (match) => labels[String(match).toLowerCase()] || match
  );
}

function areSameDisplayedNarratives(a, b) {
  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const left = normalize(a);
  const right = normalize(b);

  return Boolean(left && right && left === right);
}

function buildOverlayDirectionTitle(sourceName, targetName) {
  const source = localizeGenericPersonName(sourceName || 'Persona A');
  const target = localizeGenericPersonName(targetName || 'Persona B');

  return synText(
    `${sourceName || 'Persona A'} en casas de ${targetName || 'Persona B'}`,
    `${source} in ${target}'s houses`
  );
}

function formatCoverageLabel(coverage) {
  if (!coverage) return '—';

  const available = Number(coverage.available);
  const total = Number(coverage.total);
  const hasCounts = Number.isFinite(available) && Number.isFinite(total) && total > 0;

  if (hasCounts && available >= total) {
    return synText('Datos completos', 'Complete data');
  }

  if (hasCounts) {
    return synText(
      `Datos parciales · ${available}/${total}`,
      `Partial data · ${available}/${total}`
    );
  }

  return synText('Cobertura disponible', 'Coverage available');
}

function formatOverlaySource(value) {
  const map = {
    swiss_houses: 'Casas calculadas',
  };
  if (isEnglishPresentation()) return String(value || '').trim() === 'swiss_houses' ? 'Calculated houses' : (value || '');
  return map[String(value || '').trim()] || value || '';
}


function formatCalculationTier(value) {
  const raw = String(value || '').trim().toLowerCase();
  const map = {
    timed: 'Con hora exacta',
    mixed: 'Datos mixtos',
    date_only: 'Solo fecha',
    'con hora exacta': 'Con hora exacta',
    mixto: 'Datos mixtos',
    'datos mixtos': 'Datos mixtos',
    'solo fecha': 'Solo fecha',
  };
  if (isEnglishPresentation()) return ({ timed: 'Exact birth time', mixed: 'Mixed data', date_only: 'Date only', 'con hora exacta': 'Exact birth time', mixto: 'Mixed data', 'datos mixtos': 'Mixed data', 'solo fecha': 'Date only' })[raw] || 'Unavailable';
  return map[raw] || value || 'No disponible';
}


function formatAspectMeta(item) {
  if (!item) return synText('Aspecto sin detalle.', 'Aspect details unavailable.');

  const natureMap = {
    soft: 'armónica',
    hard: 'desafiante',
    neutral: 'neutral',
  };

  const rawNature = String(item.nature || '').trim().toLowerCase();
  const translatedNature = rawNature ? (natureMap[rawNature] || rawNature) : '';

  const englishNature = ({ soft: 'harmonious', hard: 'challenging', neutral: 'neutral' })[rawNature] || rawNature;
  const nature = translatedNature ? synText(`Naturaleza: ${translatedNature}`, `Nature: ${englishNature}`) : null;
  const orb = Number.isFinite(Number(item.orb)) ? synText(`Orbe: ${item.orb}°`, `Orb: ${item.orb}°`) : null;
  const exact = item.isExact ? synText('Exacto', 'Exact') : null;
  return [nature, orb, exact].filter(Boolean).join(' · ');
}

function localizeAspectText(text) {
  if (!text) return text;

  let result = String(text);
  if (isEnglishPresentation()) {
    return result
      .replace(/\bSol\b/gi, 'Sun').replace(/\bLuna\b/gi, 'Moon').replace(/\bMarte\b/gi, 'Mars')
      .replace(/\bJúpiter\b/gi, 'Jupiter').replace(/\bSaturno\b/gi, 'Saturn').replace(/\bUrano\b/gi, 'Uranus')
      .replace(/\bNeptuno\b/gi, 'Neptune').replace(/\bPlutón\b/gi, 'Pluto').replace(/\bAscendente\b/gi, 'Ascendant')
      .replace(/\bconjunción\b/gi, 'conjunction').replace(/\btrígono\b/gi, 'trine').replace(/\bsextil\b/gi, 'sextile')
      .replace(/\bcuadratura\b/gi, 'square').replace(/\boposición\b/gi, 'opposition').replace(/\bquincuncio\b/gi, 'quincunx');
  }

  result = result.replace(/con orbe\\s*[0-9.]+°\\.?/gi, '').trim();
  result = result.replace(ASPECT_LOCALIZE_PATTERN, (match) => ASPECT_LOCALIZE_MAP[match.toLowerCase()] ?? match);
  result = result.replace(/\\s{2,}/g, ' ').trim();

  return result;
}
function completeLegacyTruncatedOverview(text) {
  const value = String(text || '').trim();
  if (!value) return value;

  const legacyMoonCutoff =
    /(la forma de sentir de la Luna en [A-Za-zÁÉÍÓÚÜÑáéíóúüñ]+ de (?:Persona A|Persona B))\s*$/i;

  if (!legacyMoonCutoff.test(value)) return value;

  return `${value} puede sentirse distinta a la manera en que la otra persona procesa y expresa lo emocional. Esa diferencia no invalida la conexión: señala un punto donde la empatía, la comunicación clara y el respeto por los ritmos emocionales de ambos pueden volver el vínculo más fluido.`;
}

function localizeNarrativeText(text) {
  if (!text) return text;

  if (isEnglishPresentation()) {
    const raw = String(text).trim();

    if (!raw) return raw;

    const localized = localizedServerContent(raw, '');
    const base = String(localized || raw).trim();

    return localizeSynastryDisplayValue(base)
      .replace(/\bPersona A\b/g, 'Person A')
      .replace(/\bPersona B\b/g, 'Person B')
      .replace(/\bSol\b/g, 'Sun')
      .replace(/\bLuna\b/g, 'Moon')
      .replace(/\bMercurio\b/g, 'Mercury')
      .replace(/\bMarte\b/g, 'Mars')
      .replace(/\bJúpiter\b/g, 'Jupiter')
      .replace(/\bJupiter\b/g, 'Jupiter')
      .replace(/\bSaturno\b/g, 'Saturn')
      .replace(/\bUrano\b/g, 'Uranus')
      .replace(/\bNeptuno\b/g, 'Neptune')
      .replace(/\bPlutón\b/g, 'Pluto')
      .replace(/\bPluton\b/g, 'Pluto')
      .replace(/\bNodo Norte\b/g, 'North Node')
      .replace(/\bNodo Sur\b/g, 'South Node')
      .replace(/\bAscendente\b/g, 'Ascendant')
      .replace(/\bDescendente\b/g, 'Descendant')
      .replace(/\bCasa\s+(\d{1,2})\b/g, 'House $1')
      .replace(/\s+/g, ' ')
      .trim();
  }

  let result = String(text);

  NARRATIVE_LOCALIZE_ENTRIES.forEach(([en, es]) => {
    const regex = new RegExp(`\\b${en}\\b`, 'gi');
    result = result.replace(regex, es);
  });

  result = result
    .replace(/The most visible aspect today is/gi, 'Uno de los aspectos más visibles en esta sinastría es')
    .replace(/The most visible aspect is/gi, 'Uno de los aspectos más visibles en esta sinastría es')
    .replace(/with orb/gi, 'con orbe')
    .replace(/base compatibility/gi, 'compatibilidad base del')
    .replace(/today is/gi, '')
    .replace(/today's/gi, '')
    .replace(/already has a fairly populated chart for this phase/gi, 'cuenta con información completa en esta lectura')
    .replace(/has a fairly populated chart for this phase/gi, 'cuenta con información suficiente para una lectura completa')
    .replace(/The reading is already built on planetary positions and angles calculated with exact astronomical basis through Swiss Ephemeris\\.?/gi, 'La lectura ya está construida sobre posiciones planetarias y ángulos calculados con base astronómica exacta mediante Swiss Ephemeris.')
    .replace(/El aspecto más visible hoy es/gi, 'Uno de los aspectos más visibles en esta sinastría es')
    .replace(/es conjunción entre/gi, 'es la conjunción entre')
    .replace(/El aspecto más visible es/gi, 'Uno de los aspectos más visibles en esta sinastría es')
    .replace(/y eso ya le da una forma concreta al vínculo más allá de la simple compatibilidad solar/gi, 'y eso le da una forma concreta al vínculo más allá de la compatibilidad solar básica')
    .replace(/Aspectos detectados en esta fase:/gi, 'Aspectos detectados en esta lectura:')
    .replace(/Persona A ya tiene una carta bastante poblada para esta fase/gi, 'La carta de Persona A cuenta con información completa en esta lectura')
    .replace(/Persona B ya tiene una carta bastante poblada para esta fase/gi, 'La carta de Persona B cuenta con información completa en esta lectura')
    .replace(/carta bastante poblada para esta fase/gi, 'información suficiente para una lectura completa')
    .replace(/\\s{2,}/g, ' ')
    .trim();

  return result;
}

function formatAspectGuideLabel(count) {
  const n = Number(count || 0);
  if (n === 1) return synText('1 aspecto guía', '1 guiding aspect');
  return synText(`${n} aspectos guía`, `${n} guiding aspects`);
}

function getInterpretationTone(score) {
  const value = Number(score || 0);
  if (value >= 85) return synText('muy alta', 'very high');
  if (value >= 72) return synText('alta', 'high');
  if (value >= 58) return synText('media', 'medium');
  return synText('baja o parcial', 'low');
}

function getRelationshipProfile(score) {
  const value = Number(score || 0);

  if (isEnglishPresentation()) {
    if (value >= 85) return { label: 'High-synergy connection', bullets: ['Strong attraction', 'Deep emotional compatibility', 'Potential for a stable relationship'] };
    if (value >= 70) return { label: 'Growth-oriented relationship', bullets: ['Strong attraction', 'Solid compatibility', 'Potential for stability'] };
    if (value >= 55) return { label: 'Evolving relationship', bullets: ['Moderate attraction', 'Mutual growth', 'Requires conscious effort'] };
    return { label: 'Challenging relationship', bullets: ['Uneven attraction', 'Important differences', 'Requires significant awareness'] };
  }

  if (value >= 85) {
    return {
      label: 'Vínculo de alta sinergia',
      bullets: ['Alta atracción', 'Gran compatibilidad emocional', 'Potencial de relación estable']
    };
  }

  if (value >= 70) {
    return {
      label: 'Relación de crecimiento',
      bullets: ['Alta atracción', 'Compatibilidad sólida', 'Potencial de estabilidad']
    };
  }

  if (value >= 55) {
    return {
      label: 'Relación evolutiva',
      bullets: ['Atracción moderada', 'Aprendizaje mutuo', 'Necesita trabajo consciente']
    };
  }

  return {
    label: 'Relación desafiante',
    bullets: ['Atracción irregular', 'Diferencias importantes', 'Requiere mucha conciencia']
  };
}

function getCompatibilityVisualProfile(score) {
  const value = Number(score || 0);

  if (value >= 85) {
    return {
      ring: 'conic-gradient(from 210deg, #F7D774 0deg, #F7D774 220deg, #8A2BE2 320deg, rgba(255,255,255,0.08) 360deg)',
      glow: '0 0 34px rgba(247,215,116,0.22)',
    };
  }

  if (value >= 70) {
    return {
      ring: 'conic-gradient(from 210deg, #F7D774 0deg, #DAA520 190deg, #8A2BE2 300deg, rgba(255,255,255,0.08) 360deg)',
      glow: '0 0 28px rgba(218,165,32,0.18)',
    };
  }

  if (value >= 55) {
    return {
      ring: 'conic-gradient(from 210deg, #D9C7FF 0deg, #8A2BE2 200deg, #DAA520 300deg, rgba(255,255,255,0.08) 360deg)',
      glow: '0 0 24px rgba(138,43,226,0.16)',
    };
  }

  return {
    ring: 'conic-gradient(from 210deg, #C98A8A 0deg, #B24C4C 170deg, #6A0DAD 290deg, rgba(255,255,255,0.08) 360deg)',
    glow: '0 0 24px rgba(178,76,76,0.16)',
  };
}

function isRedundantStrengthOverlay(item) {
  const text = String(item || '')
    .replace(/\s+/g, ' ')
    .trim();

  if (!text) return false;

  // Filtramos únicamente frases que comienzan inequívocamente describiendo
  // un overlay planeta/punto -> casa entre Persona A y Persona B.
  //
  // Ejemplos:
  // "Luna de Persona A en Casa 4 de Persona B..."
  // "Nodo Norte de Persona B en Casa 7 de Persona A..."
  //
  // No usamos palabras genéricas como "magnetismo", "estabilidad",
  // "aprendizaje", etc., para no eliminar conclusiones valiosas.
  const overlayLeadPattern =
    /^(?:sol|luna|mercurio|venus|marte|j[uú]piter|saturno|urano|neptuno|plut[oó]n|nodo norte|nodo sur|ascendente|descendente)\s+de\s+persona\s+[ab]\s+en\s+casa\s+(?:[1-9]|1[0-2])\s+de\s+persona\s+[ab]\b/i;

  return overlayLeadPattern.test(text);
}

function buildDistinctDirectionalOverlayInterpretation(item) {
  const summary = String(item?.summaryText || '')
    .replace(/\s+/g, ' ')
    .trim();

  const originalInterpretation = String(item?.interpretation || '')
    .replace(/\s+/g, ' ')
    .trim();

  if (!originalInterpretation) return '';

  const match = summary.match(
    /^(Sol|Luna|Mercurio|Venus|Marte|Júpiter|Jupiter|Saturno|Urano|Neptuno|Plutón|Pluton|Nodo Norte|Nodo Sur|Ascendente|Descendente)\s+de\s+(Persona\s+[AB])\s+en\s+Casa\s+(\d{1,2})\s+de\s+(Persona\s+[AB])$/i
  );

  // Cualquier formato inesperado conserva la lógica segura existente.
  if (!match) {
    return compactRepeatedNarrativeLead(
      summary,
      originalInterpretation
    );
  }

  const rawPoint = match[1];
  const sourcePerson = match[2];
  const houseNumber = Number(match[3]);
  const targetPerson = match[4];

  if (
    !Number.isInteger(houseNumber) ||
    houseNumber < 1 ||
    houseNumber > 12
  ) {
    return compactRepeatedNarrativeLead(
      summary,
      originalInterpretation
    );
  }

  const pointKey = rawPoint
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

  const pointMeaningMap = {
    sol: synText(
      `${rawPoint} aporta identidad, vitalidad y una presencia muy visible de ${sourcePerson}.`,
      `${rawPoint} brings identity, vitality, and a highly visible presence from ${sourcePerson}.`
    ),

    luna: synText(
      `${rawPoint} aporta sensibilidad, necesidad de contención y una respuesta emocional profunda de ${sourcePerson}.`,
      `${rawPoint} brings sensitivity, emotional needs, and a deep emotional response from ${sourcePerson}.`
    ),

    mercurio: synText(
      `${rawPoint} activa conversación, curiosidad, ideas e intercambio mental desde ${sourcePerson}.`,
      `${rawPoint} activates conversation, curiosity, ideas, and mental exchange from ${sourcePerson}.`
    ),

    venus: synText(
      `${rawPoint} aporta afinidad, atracción, disfrute y una forma más suave de vincularse desde ${sourcePerson}.`,
      `${rawPoint} brings affinity, attraction, enjoyment, and a softer way of relating from ${sourcePerson}.`
    ),

    marte: synText(
      `${rawPoint} agrega impulso, deseo, iniciativa y una energía más directa desde ${sourcePerson}.`,
      `${rawPoint} adds drive, desire, initiative, and a more direct energy from ${sourcePerson}.`
    ),

    jupiter: synText(
      `${rawPoint} amplía posibilidades, confianza y sensación de crecimiento desde ${sourcePerson}.`,
      `${rawPoint} expands possibilities, confidence, and a sense of growth from ${sourcePerson}.`
    ),

    saturno: synText(
      `${rawPoint} aporta estructura, responsabilidad y necesidad de construir algo sostenible desde ${sourcePerson}.`,
      `${rawPoint} brings structure, responsibility, and a need to build something sustainable from ${sourcePerson}.`
    ),

    urano: synText(
      `${rawPoint} introduce cambio, sorpresa, libertad y una dinámica menos convencional desde ${sourcePerson}.`,
      `${rawPoint} introduces change, surprise, freedom, and a less conventional dynamic from ${sourcePerson}.`
    ),

    neptuno: synText(
      `${rawPoint} vuelve el vínculo más sensible, intuitivo, idealizado y difícil de definir racionalmente.`,
      `${rawPoint} makes the connection more sensitive, intuitive, idealized, and difficult to define rationally.`
    ),

    pluton: synText(
      `${rawPoint} intensifica la experiencia y puede volverla transformadora, magnética o imposible de vivir con indiferencia.`,
      `${rawPoint} intensifies the experience and can make it transformative, magnetic, or impossible to experience indifferently.`
    ),

    'nodo norte': synText(
      `${rawPoint} señala una zona especialmente significativa para el aprendizaje y la evolución compartida entre ${sourcePerson} y ${targetPerson}.`,
      `${rawPoint} points to an especially meaningful area for shared learning and growth between ${sourcePerson} and ${targetPerson}.`
    ),

    'nodo sur': synText(
      `${rawPoint} activa familiaridad, patrones conocidos y una sensación de terreno ya transitado entre ${sourcePerson} y ${targetPerson}.`,
      `${rawPoint} activates familiarity, known patterns, and a sense of already-traveled territory between ${sourcePerson} and ${targetPerson}.`
    ),

    ascendente: synText(
      `${rawPoint} hace que la presencia, identidad visible y forma de mostrarse de ${sourcePerson} tengan un impacto muy directo.`,
      `${rawPoint} makes ${sourcePerson}'s presence, visible identity, and self-expression have a very direct impact.`
    ),

    descendente: synText(
      `${rawPoint} activa de forma directa el eje de pareja, asociación y espejo relacional entre ${sourcePerson} y ${targetPerson}.`,
      `${rawPoint} directly activates the axis of partnership, association, and relational mirroring between ${sourcePerson} and ${targetPerson}.`
    ),
  };

  const houseMeaningMap = {
    1: synText(
      `Esta influencia se refleja con fuerza en la identidad, presencia, imagen y primera impresión de ${targetPerson}.`,
      `This influence is strongly reflected in ${targetPerson}'s identity, presence, image, and first impressions.`
    ),

    2: synText(
      `El efecto se concentra en la seguridad, autoestima, recursos, posesiones y sistema de valores de ${targetPerson}.`,
      `The effect centers on ${targetPerson}'s security, self-worth, resources, possessions, and values.`
    ),

    3: synText(
      `La dinámica se percibe principalmente en la comunicación cotidiana, las ideas, el aprendizaje y el intercambio de ${targetPerson}.`,
      `The dynamic is felt mainly through ${targetPerson}'s daily communication, ideas, learning, and exchange.`
    ),

    4: synText(
      `El vínculo toca especialmente el hogar emocional, la intimidad, las raíces, la familia y la sensación de pertenencia de ${targetPerson}.`,
      `The connection especially touches ${targetPerson}'s emotional home, intimacy, roots, family, and sense of belonging.`
    ),

    5: synText(
      `Esta energía se expresa en el romance, la creatividad, el juego, el deseo, el placer y la espontaneidad de ${targetPerson}.`,
      `This energy is expressed through ${targetPerson}'s romance, creativity, play, desire, pleasure, and spontaneity.`
    ),

    6: synText(
      `En la vida cotidiana de ${targetPerson}, influye sobre rutinas, hábitos, cuidado, trabajo diario y convivencia práctica.`,
      `In ${targetPerson}'s daily life, it influences routines, habits, care, everyday work, and practical coexistence.`
    ),

    7: synText(
      `En el plano de la pareja de ${targetPerson}, impacta directamente el compromiso, la asociación y el espejo relacional.`,
      `In ${targetPerson}'s partnership sphere, it directly affects commitment, association, and relational mirroring.`
    ),

    8: synText(
      `La conexión profundiza en ${targetPerson} la intimidad, la confianza, la sexualidad, la vulnerabilidad y la transformación compartida.`,
      `The connection deepens ${targetPerson}'s intimacy, trust, sexuality, vulnerability, and shared transformation.`
    ),

    9: synText(
      `Esta influencia impulsa en ${targetPerson} las creencias, la expansión, los viajes, la visión de vida y el sentido de futuro.`,
      `This influence activates ${targetPerson}'s beliefs, expansion, travel, life vision, and sense of future.`
    ),

    10: synText(
      `La energía se proyecta sobre la dirección, los objetivos, la admiración, la reputación y la proyección pública de ${targetPerson}.`,
      `The energy projects onto ${targetPerson}'s direction, goals, admiration, reputation, and public projection.`
    ),

    11: synText(
      `El vínculo se expresa en la amistad, los proyectos, las redes, los ideales y el futuro compartido de ${targetPerson}.`,
      `The connection is expressed through ${targetPerson}'s friendship, projects, networks, ideals, and shared future.`
    ),

    12: synText(
      `La conexión actúa sobre el mundo inconsciente, el misterio, la sensibilidad psíquica y los procesos internos profundos de ${targetPerson}.`,
      `The connection acts on ${targetPerson}'s unconscious world, mystery, psychic sensitivity, and deep inner processes.`
    ),
  };

  const pointMeaning = pointMeaningMap[pointKey];
  const houseMeaning = houseMeaningMap[houseNumber];

  if (!pointMeaning || !houseMeaning) {
    return compactRepeatedNarrativeLead(
      summary,
      originalInterpretation
    );
  }

  return `${pointMeaning} ${houseMeaning}`;
}

function compactRepeatedNarrativeLead(summary, interpretation) {
  const heading = String(summary || '').replace(/\s+/g, ' ').trim();
  const body = String(interpretation || '').replace(/\s+/g, ' ').trim();

  if (!body || !heading) return body;

  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9ñáéíóúü\s]/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();

  const headingKey = normalize(heading);

  const sentences =
    body.match(/[^.!?…]+[.!?…]?/g) || [body];

  const firstSentence = String(sentences[0] || '').trim();
  const firstKey = normalize(firstSentence);

  const stopWords = new Set([
    'a', 'al', 'de', 'del', 'el', 'en', 'entre', 'la', 'las',
    'lo', 'los', 'por', 'que', 'se', 'su', 'sus', 'un', 'una',
    'y', 'the', 'of', 'in', 'to', 'and', 'a', 'an',
  ]);

  const headingWords = headingKey
    .split(' ')
    .filter((word) => word && !stopWords.has(word));

  const firstWords = firstKey
    .split(' ')
    .filter((word) => word && !stopWords.has(word));

  const sharedWords = headingWords.filter((word) =>
    firstWords.includes(word)
  );

  const overlap = headingWords.length
    ? sharedWords.length / headingWords.length
    : 0;

  const repeatsHeading =
    firstKey.startsWith(headingKey) ||
    headingKey.startsWith(firstKey) ||
    (headingWords.length >= 4 && overlap >= 0.8);

  if (!repeatsHeading) return body;

  const compacted = sentences
    .slice(1)
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();

  return compacted || body;
}

function renderHighlightedOverviewText(text, names = []) {
  const rawText = String(text || '').trim();
  const safeNames = Array.from(
    new Set(
      (Array.isArray(names) ? names : [])
        .map((name) => String(name || '').trim())
        .filter(Boolean)
    )
  );

  if (!rawText) return null;
  if (!safeNames.length) return rawText;

  const escapedNames = safeNames
    .map((name) => name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .sort((a, b) => b.length - a.length);

  const pattern = new RegExp(`\\b(${escapedNames.join('|')})\\b`, 'g');
  const parts = rawText.split(pattern);

  return parts.map((part, index) => {
    if (!part) return null;
    if (safeNames.includes(part)) {
      return (
        <span key={`overview-name-${part}-${index}`} style={styles.overviewNarrativeName}>
          {part}
        </span>
      );
    }
    return <React.Fragment key={`overview-text-${index}`}>{part}</React.Fragment>;
  });
}

function renderHighlightedOverlayText(text, names = [], extraTokens = []) {
  const rawText = String(text || '').trim();
  if (!rawText) return null;

  const safeTokens = Array.from(
    new Set(
      [
        ...(Array.isArray(names) ? names : []),
        ...(Array.isArray(extraTokens) ? extraTokens : []),
      ]
        .map((value) => String(value || '').trim())
        .filter(Boolean)
    )
  );

  if (!safeTokens.length) return rawText;

  const escapedTokens = safeTokens
    .map((token) => token.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
    .sort((a, b) => b.length - a.length);

  const pattern = new RegExp(`\\b(${escapedTokens.join('|')})\\b`, 'g');
  const parts = rawText.split(pattern);

  return parts.map((part, index) => {
    if (!part) return null;
    if (safeTokens.includes(part)) {
      return (
        <span key={`overlay-token-${part}-${index}`} style={styles.overlayTokenHighlight}>
          {part}
        </span>
      );
    }
    return <React.Fragment key={`overlay-text-${index}`}>{part}</React.Fragment>;
  });
}

function SectionFrame({ title, right, children }) {
  return (
    <div style={styles.card}>
      {(title || right) ? (
        <div style={{ ...styles.reliabilityHeader, marginBottom: 14 }}>
          {title ? <h3 style={{ ...styles.sectionTitle, marginBottom: 0 }}>{title}</h3> : <span />}
          {right || null}
        </div>
      ) : null}
      {children}
    </div>
  );
}

function PlanetList({ title, chart = {}, coverageLabel }) {
  const sourceValues = PLANET_ORDER
    .map((key) => String(chart?.[key]?.source || '').trim())
    .filter(Boolean);

  const usesSwissEphemeris = sourceValues.some((source) => /swiss/i.test(source));
  const hasPartialData = PLANET_ORDER.some((key) => chart?.[key]?.certain === false);

  return (
    <div style={styles.chartCard}>
      <div style={{ ...styles.reliabilityHeader, marginBottom: 10 }}>
        <div style={{ display: 'grid', gap: 4, minWidth: 0 }}>
          <h3 style={{ ...styles.sectionTitle, marginBottom: 0 }}>{localizeGenericPersonName(title)}</h3>

          {usesSwissEphemeris ? (
            <span
              style={{
                color: 'rgba(255,243,196,0.62)',
                fontSize: 11,
                lineHeight: 1.35,
              }}
            >
              {synText(
                'Precisión astronómica · Swiss Ephemeris',
                'Astronomical precision · Swiss Ephemeris'
              )}
            </span>
          ) : null}
        </div>

        <div
          style={{
            display: 'flex',
            gap: 6,
            flexWrap: 'wrap',
            justifyContent: 'flex-end',
          }}
        >
          {coverageLabel ? (
            <span style={styles.microBadge}>{coverageLabel}</span>
          ) : null}

          {hasPartialData ? (
            <span style={styles.microBadge}>
              {synText('Algunos datos parciales', 'Some partial data')}
            </span>
          ) : null}
        </div>
      </div>

      {PLANET_ORDER.map((key) => {
        const planet = chart[key];
        if (!planet) return null;

        const degree = formatDegreeValue(
          planet.degreeInSign ?? planet.degree
        );

        return (
          <div key={key} style={styles.planetRow}>
            <div style={styles.planetLeft}>
              <span style={styles.planetName}>
                {presentationLabel(
                  PLANET_LABELS,
                  PLANET_LABELS_EN,
                  key
                )}
              </span>
            </div>

            <div style={styles.planetRight}>
              <span style={styles.planetValue}>
                {localizeSynastryDisplayValue(formatPlanetValue(planet))}
              </span>

              <span style={styles.planetSubValue}>
                {degree || '—'}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}

function DimensionCard({ label, data }) {
  if (!data) return null;
  const pct = Math.max(0, Math.min(100, Number(data.score || 0)));
  const keyAspects = normalizeArray(data.keyAspects);
  const tone = getInterpretationTone(pct);

  return (
    <div style={styles.dimCard}>
      <div aria-hidden style={styles.dimGlowA} />
      <div aria-hidden style={styles.dimGlowB} />

      <div style={styles.dimHeader}>
        <strong style={{ color: '#FFF3C4', fontSize: 15, lineHeight: 1.2 }}>{label}</strong>
        <strong style={styles.dimScore}>{pct}%</strong>
      </div>

      <div style={styles.dimMeta}>
        <span style={styles.microBadge}>
          {data.certain === false
            ? synText('Parcial', 'Partial')
            : synText('Completa', 'Complete')}
        </span>
        <span style={styles.microBadge}>
          {`${synText('Intensidad', 'Intensity')} ${tone}`}
        </span>
        {keyAspects.length ? <span style={styles.microBadge}>{formatAspectGuideLabel(keyAspects.length)}</span> : null}
      </div>

      <div style={styles.dimBar}>
        <div style={{ ...styles.dimFill, width: `${pct}%` }} />
      </div>

      {(() => {
        const certaintyText = data.certaintyNote
          ? localizeNarrativeText(data.certaintyNote)
          : '';

        const interpretationText = data.interpretation
          ? localizeNarrativeText(
              localizeDisplayedAspectText(data.interpretation)
            )
          : '';

        const showInterpretation =
          interpretationText &&
          !areSameDisplayedNarratives(
            certaintyText,
            interpretationText
          );

        return (
          <>
            {certaintyText ? (
              <p
                style={{
                  ...styles.dimInterpretation,
                  color: 'rgba(255,243,196,0.70)',
                }}
              >
                {certaintyText}
              </p>
            ) : null}

            {showInterpretation ? (
              <p style={styles.dimInterpretation}>
                {interpretationText}
              </p>
            ) : null}
          </>
        );
      })()}

      {keyAspects.length ? (
        <ul style={styles.aspectList}>
          {keyAspects.map((item, idx) => (
            <li key={`${label}-${idx}`}>{localizeDisplayedAspectText(item)}</li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}


function localizeOverlayText(value) {
  const raw = String(value || '').trim();

  if (!raw || !isEnglishPresentation()) return raw;

  return localizeNarrativeText(raw)
    .replace(/\bde Person A\b/g, 'of Person A')
    .replace(/\bde Person B\b/g, 'of Person B')
    .replace(/\ben House\b/gi, 'in House')
    .replace(/\bcae en House\b/gi, 'falls in House')
    .replace(/\bcae in House\b/gi, 'falls in House')
    .replace(/\s+/g, ' ')
    .trim();
}

function localizeOverlayBadge(value) {
  const raw = String(value || '').trim();

  if (!raw || !isEnglishPresentation()) return raw;

  return localizeSynastryDisplayValue(raw)
    .replace(/^Casa\s+(\d{1,2})$/i, 'House $1')
    .replace(/^Sol$/i, 'Sun')
    .replace(/^Luna$/i, 'Moon')
    .replace(/^Mercurio$/i, 'Mercury')
    .replace(/^Venus$/i, 'Venus')
    .replace(/^Marte$/i, 'Mars')
    .replace(/^Júpiter$/i, 'Jupiter')
    .replace(/^Jupiter$/i, 'Jupiter')
    .replace(/^Saturno$/i, 'Saturn')
    .replace(/^Urano$/i, 'Uranus')
    .replace(/^Neptuno$/i, 'Neptune')
    .replace(/^Plutón$/i, 'Pluto')
    .replace(/^Pluton$/i, 'Pluto')
    .replace(/^Nodo Norte$/i, 'North Node')
    .replace(/^Nodo Sur$/i, 'South Node')
    .replace(/^Ascendente$/i, 'Ascendant')
    .replace(/^Descendente$/i, 'Descendant');
}

function OverlayDirectionalColumn({ title, data }) {
  const overlays = normalizeArray(data?.overlays).slice(0, 8);
  const highlightNames = [
  ...new Set(
    overlays
      .flatMap((item) => [item?.sourceName, item?.targetName])
      .map((value) => String(value || '').trim())
      .filter(Boolean)
  ),
];
  return (
    <div style={styles.chartCard}>
      <div style={styles.reliabilityHeader}>
        <h3 style={{ ...styles.sectionTitle, marginBottom: 0 }}>{title}</h3>
        {data?.missingHouses ? <span style={styles.microBadge}>{synText('Casas faltantes', 'Missing houses')}</span> : null}
      </div>
      {overlays.length ? (
        <div style={styles.overlayList}>
          {overlays.map((item, idx) => (
            <div key={`${title}-${idx}`} style={styles.overlayItem}>
              <div style={styles.reliabilityMeta}>
                {item.houseLabel ? (
                  <span style={styles.microBadge}>
                    {localizeOverlayBadge(item.houseLabel)}
                  </span>
                ) : null}
                {item.pointLabel ? (
                  <span style={styles.microBadge}>
                    {localizeOverlayBadge(item.pointLabel)}
                  </span>
                ) : null}
              </div>
              <p style={styles.overlayItemTitle}>
                {renderHighlightedOverlayText(localizeOverlayText(item.summaryText), highlightNames, [
                  'Sol',
                  'Luna',
                  'Mercurio',
                  'Venus',
                  'Marte',
                  'Júpiter',
                  'Saturno',
                  'Urano',
                  'Neptuno',
                  'Plutón',
                  'Nodo Norte',
                  'Nodo Sur',
                  'Ascendente',
                  'Descendente',
                  'Casa 1',
                  'Casa 2',
                  'Casa 3',
                  'Casa 4',
                  'Casa 5',
                  'Casa 6',
                  'Casa 7',
                  'Casa 8',
                  'Casa 9',
                  'Casa 10',
                  'Casa 11',
                  'Casa 12',
                ])}
              </p>
              {item.interpretation ? (() => {
                const distinctInterpretation =
                  buildDistinctDirectionalOverlayInterpretation(item);

                return distinctInterpretation ? (
                  <p style={styles.overlayItemMeta}>
                    {renderHighlightedOverlayText(
                      distinctInterpretation,
                      highlightNames,
                      [
                        'Sol',
                        'Luna',
                        'Mercurio',
                        'Venus',
                        'Marte',
                        'Júpiter',
                        'Saturno',
                        'Urano',
                        'Neptuno',
                        'Plutón',
                        'Nodo Norte',
                        'Nodo Sur',
                        'Ascendente',
                        'Descendente',
                        'Casa 1',
                        'Casa 2',
                        'Casa 3',
                        'Casa 4',
                        'Casa 5',
                        'Casa 6',
                        'Casa 7',
                        'Casa 8',
                        'Casa 9',
                        'Casa 10',
                        'Casa 11',
                        'Casa 12',
                      ]
                    )}
                  </p>
                ) : null;
              })() : null}
            </div>
          ))}
        </div>
     ) : <p style={styles.text}>{synText('Todavía no hay cruces de casas destacados para esta dirección.', 'There are no highlighted house overlays in this direction yet.')}</p>}
    </div>
  );
}

export default function DeepModeTab({ initialSavedReading = null }) {
  const navigate = useNavigate();

  useEffect(() => {
    clearLegacySavedSynastryStorage();
  }, []);
  
  
  const [personA, setPersonA] = useState(() => (
  initialSavedReading
    ? normalizeSavedPerson(initialSavedReading?.personA, 'Persona A')
    : { ...emptyPerson(), nickname: 'Persona A' }
));

const [personB, setPersonB] = useState(() => (
  initialSavedReading
    ? normalizeSavedPerson(initialSavedReading?.personB, 'Persona B')
    : { ...emptyPerson(), nickname: 'Persona B' }
));

const [loading, setLoading] = useState(false);
const [result, setResult] = useState(() => getSavedResultPayload(initialSavedReading));
  const [error, setError] = useState(null);
  const [saveError, setSaveError] = useState(null);
  const [saveSuccess, setSaveSuccess] = useState(null);
    const [saving, setSaving] = useState(false);
      const savingRef = useRef(false);
      const sharingRef = useRef(false);
  const lastSavedFingerprintRef = useRef('');
  const [showTechA, setShowTechA] = useState(false);
  const [showTechB, setShowTechB] = useState(false);
  const [placeEditUnlockedA, setPlaceEditUnlockedA] = useState(() => !initialSavedReading);
  const [placeEditUnlockedB, setPlaceEditUnlockedB] = useState(() => !initialSavedReading);
  const [isMobile, setIsMobile] = useState(() => (typeof window === 'undefined' ? false : window.innerWidth <= 768));
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [shareCardBusy, setShareCardBusy] = useState(false);

        const {
    questions: guidedQuestions,
    loadingQuestions: loadingGuidedQuestions,
    loadingQuestionId,
    activeQuestionId,
    askedQuestionIds,
    activeInterpretation,
    error: guidedInterpretationError,
    dailyUsage,
    freeQuestionInput,
    setFreeQuestionInput,
    loadingFreeQuestion,
    freeQuestionHistory,
    setReading: setGuidedReading,
    loadQuestions: loadGuidedQuestions,
    askQuestion,
    askFreeQuestion,
    resetState: resetGuidedInterpretationState,
    } = useSynastryInterpretation();
  
  useEffect(() => {
    if (!result || typeof result !== 'object') {
      resetGuidedInterpretationState(null);
      return;
    }

    setGuidedReading(result);
    loadGuidedQuestions(result);
  }, [result, loadGuidedQuestions, resetGuidedInterpretationState, setGuidedReading]);

const normalizedInitialSavedReading = useMemo(() => {
  if (!initialSavedReading) return null;

  return {
    personA: normalizeSavedPerson(initialSavedReading?.personA, 'Persona A'),
    personB: normalizeSavedPerson(initialSavedReading?.personB, 'Persona B'),
    result: getSavedResultPayload(initialSavedReading),
  };
}, [initialSavedReading]);

  useEffect(() => {
  let rafId = 0;

  function handleResize() {
    if (rafId) window.cancelAnimationFrame(rafId);
    rafId = window.requestAnimationFrame(() => {
      setIsMobile(window.innerWidth <= 768);
    });
  }

  window.addEventListener('resize', handleResize);
  return () => {
    if (rafId) window.cancelAnimationFrame(rafId);
    window.removeEventListener('resize', handleResize);
  };
}, []);

useLayoutEffect(() => {
    if (!isMobile || typeof window === 'undefined') return undefined;

    let rafOne = 0;
    let rafTwo = 0;
    let timer = 0;

    const settleLayout = () => {
      const root = document.getElementById('synastryDeepMobileScroller') || document.scrollingElement || document.documentElement;
      if (!root) return;

      // Force the browser to calculate the final deep-tab height before the user's first pan.
      void root.clientHeight;
      void root.scrollHeight;
      void document.body.offsetHeight;
      void document.documentElement.offsetHeight;
    };

    settleLayout();
    rafOne = window.requestAnimationFrame(() => {
      settleLayout();
      rafTwo = window.requestAnimationFrame(settleLayout);
    });
    timer = window.setTimeout(settleLayout, 180);

    return () => {
      if (rafOne) window.cancelAnimationFrame(rafOne);
      if (rafTwo) window.cancelAnimationFrame(rafTwo);
      if (timer) window.clearTimeout(timer);
    };
  }, [isMobile]);
  useEffect(() => {
  if (!normalizedInitialSavedReading) return;

  setPersonA({
  ...normalizedInitialSavedReading.personA,
  birthTimeHour: String(normalizedInitialSavedReading.personA?.birthTime || '').match(/^(\d{2}):(\d{2})$/)?.[1] || '',
  birthTimeMinute: String(normalizedInitialSavedReading.personA?.birthTime || '').match(/^(\d{2}):(\d{2})$/)?.[2] || '',
});

setPersonB({
  ...normalizedInitialSavedReading.personB,
  birthTimeHour: String(normalizedInitialSavedReading.personB?.birthTime || '').match(/^(\d{2}):(\d{2})$/)?.[1] || '',
  birthTimeMinute: String(normalizedInitialSavedReading.personB?.birthTime || '').match(/^(\d{2}):(\d{2})$/)?.[2] || '',
});
  setResult(normalizedInitialSavedReading.result);
  setError(null);
  setSaveError(null);
  setSaveSuccess(null);
  setPlaceEditUnlockedA(false);
  setPlaceEditUnlockedB(false);
}, [normalizedInitialSavedReading]);

  const canSubmit = useMemo(() => {
    const baseA = personA.nickname && personA.birthDate;
    const baseB = personB.nickname && personB.birthDate;
    const timeAOk = !personA.hasTime || (personA.birthTime && personA.birthCity && personA.birthCountry);
    const timeBOk = !personB.hasTime || (personB.birthTime && personB.birthCity && personB.birthCountry);
    return Boolean(baseA && baseB && timeAOk && timeBOk && !loading);
  }, [personA, personB, loading]);

    const guidedPanel = result ? (
  <GuidedQuestionsPanel
    questions={guidedQuestions}
    loadingQuestions={loadingGuidedQuestions}
    loadingQuestionId={loadingQuestionId}
    activeQuestionId={activeQuestionId}
    askedQuestionIds={askedQuestionIds}
    activeInterpretation={activeInterpretation}
    error={guidedInterpretationError}
    dailyUsage={dailyUsage}
    freeQuestionInput={freeQuestionInput}
    setFreeQuestionInput={setFreeQuestionInput}
    loadingFreeQuestion={loadingFreeQuestion}
    freeQuestionHistory={freeQuestionHistory}
    onAskFreeQuestion={(input) => askFreeQuestion(input, { reading: result })}
    onAskQuestion={(question) => askQuestion(question, { reading: result })}
  />
) : null;
  
  

  function updatePerson(which, field, value) {
    const setter = which === 'A' ? setPersonA : setPersonB;
    setter((prev) => ({ ...prev, [field]: value }));
  }

  function toggleHasTime(which, checked) {
    const setter = which === 'A' ? setPersonA : setPersonB;
    setter((prev) => ({
  ...prev,
  hasTime: checked,
  birthTime: checked ? prev.birthTime : '',
birthTimeHour: checked ? prev.birthTimeHour : '',
birthTimeMinute: checked ? prev.birthTimeMinute : '',
  birthCity: checked ? prev.birthCity : '',
  birthCountry: checked ? prev.birthCountry : '',
  birthPlaceLabel: checked ? prev.birthPlaceLabel : '',
  lat: checked ? prev.lat : '',
  lng: checked ? prev.lng : '',
  timezoneOffsetMinutes: checked ? prev.timezoneOffsetMinutes : '',
  birthTimezone: checked ? prev.birthTimezone : '',
}));
  }

  function handlePlaceInput(which, nextValue) {
    const setter = which === 'A' ? setPersonA : setPersonB;
    if (which === 'A') setPlaceEditUnlockedA(true);
    if (which === 'B') setPlaceEditUnlockedB(true);
    setter((prev) => ({
      ...prev,
      birthCity: nextValue,
      birthCountry: '',
      birthPlaceLabel: '',
      lat: '',
      lng: '',
      timezoneOffsetMinutes: '',
      birthTimezone: '',
    }));
  }

  function handlePlaceSelect(which, place) {
    const setter = which === 'A' ? setPersonA : setPersonB;
    if (which === 'A') setPlaceEditUnlockedA(true);
    if (which === 'B') setPlaceEditUnlockedB(true);
    setter((prev) => placeApi.hydrateBirthLocation(prev, place));
  }

  function hasResolvedPlace(person) {
    return Boolean(person?.birthCity && person?.birthCountry && person?.lat !== '' && person?.lng !== '');
  }

  function getResolvedPlaceRegion(person) {
    const label = String(person?.birthPlaceLabel || '').trim();
    if (!label) return person?.birthCountry || '';
    const parts = label.split(',').map((part) => part.trim()).filter(Boolean);
    if (parts.length >= 3) return `${parts[1]}, ${parts[2]}`;
    if (parts.length >= 2) return parts.slice(1).join(', ');
    return person?.birthCountry || '';
  }

  function formatTechValue(value) {
    return value === '' || value == null ? '—' : String(value);
  }

function handleOpenCosmicLibrary() {
  navigate('/saved-synastries', {
    state: { from: 'deep' }
  });
}

  async function handleOpenSynastryComparison(event) {
    // No preventDefault acá: en mobile puede robar el primer pan vertical y trabar el scroll.
    if (event?.stopPropagation) event.stopPropagation();

    setSaveError(null);
    setSaveSuccess(null);

    if (!result) {
      setSaveError('Primero calculá o abrí una lectura antes de comparar otra pareja.');
      return;
    }


    let savedItems = readSavedSynastriesFromStorage();

    try {
      const response = await listSavedSynastries(50);
      const apiItems = Array.isArray(response?.items) ? response.items : [];

      const detailedApiItems = await Promise.all(
        apiItems.map(async (item) => {
          const itemId = String(item?.id || item?._id || '').trim();
          if (!itemId) return item;
          try {
            const detail = await getSavedSynastryById(itemId);
            return detail?.item || detail || item;
          } catch {
            return item;
          }
        })
      );

      savedItems = mergeSavedSynastriesByIdentity(detailedApiItems);
    } catch (err) {
      // The existing visible empty-state message handles this failure.
    }

    const deepCandidates = savedItems.filter((rawItem) => {
      const item = unwrapSavedSynastryItem(rawItem);

      const payload =
        item?.result ||
        item?.reading ||
        item?.analysis ||
        item?.synastry ||
        item?.resultSnapshot ||
        item;

      const inferredMode = inferSavedReadingMode(payload);

      const itemFingerprint = String(item?.fingerprint || '').trim();
      const currentFingerprint = buildSaveFingerprint();

      if (inferredMode !== 'deep') return false;

      if (itemFingerprint && currentFingerprint && itemFingerprint === currentFingerprint) {
        return false;
      }

      return true;
    });

    if (!deepCandidates.length) {
      setSaveError('Necesitás al menos otra lectura deep guardada para comparar esta sinastría profunda.');
      return;
    }

    navigate('/synastry-comparison', {
      state: {
        from: 'deep',
        currentReading: result,
        currentPeople: {
          personA: {
            nickname: personA.nickname || 'Persona A',
            sign:
              result?.personA?.sign ||
              result?.personA?.zodiacSign ||
              result?.people?.personA?.sign ||
              result?.people?.personA?.zodiacSign ||
              personA.sign ||
              personA.zodiacSign ||
              personA.sunSign ||
              '',
            sunSign:
              result?.personA?.sign ||
              result?.personA?.zodiacSign ||
              result?.people?.personA?.sign ||
              result?.people?.personA?.zodiacSign ||
              personA.sign ||
              personA.zodiacSign ||
              personA.sunSign ||
              '',
            birthDate: personA.birthDate || '',
            birthTime: personA.birthTime || '',
            birthCity: personA.birthCity || '',
            birthCountry: personA.birthCountry || '',
          },
          personB: {
            nickname: personB.nickname || 'Persona B',
            sign:
              result?.personB?.sign ||
              result?.personB?.zodiacSign ||
              result?.people?.personB?.sign ||
              result?.people?.personB?.zodiacSign ||
              personB.sign ||
              personB.zodiacSign ||
              personB.sunSign ||
              '',
            sunSign:
              result?.personB?.sign ||
              result?.personB?.zodiacSign ||
              result?.people?.personB?.sign ||
              result?.people?.personB?.zodiacSign ||
              personB.sign ||
              personB.zodiacSign ||
              personB.sunSign ||
              '',
            birthDate: personB.birthDate || '',
            birthTime: personB.birthTime || '',
            birthCity: personB.birthCity || '',
            birthCountry: personB.birthCountry || '',
          },
        },
        readingMode: 'deep',
        savedCandidates: deepCandidates,
      },
    });
  }

  async function handleShareReading() {
    try {
      if (!result) {
        setSaveError('Primero calculá una lectura antes de compartirla.');
        setSaveSuccess(null);
        return;
      }

      if (sharingRef.current) {
        return;
      }

      const payload = sharePayload;
      setSaveError(null);
      setSaveSuccess(null);

      if (!isLikelyNativeShareDevice()) {
        setShareModalOpen(true);
        return;
      }

      if (typeof navigator === 'undefined' || typeof navigator.share !== 'function') {
        setShareModalOpen(true);
        return;
      }

      sharingRef.current = true;

      await navigator.share({
        title: `Compatibilidad Zodiacus · ${payload.pairLabel}`,
        text: payload.shareText,
      });

      setSaveSuccess('Lectura compartida con éxito.');
    } catch (err) {
      if (err?.name === 'AbortError') {
        return;
      }
      if (err?.name === 'InvalidStateError') {
        setSaveError('Esperá un instante antes de volver a compartir la lectura.');
        setSaveSuccess(null);
        return;
      }
      setSaveError('No se pudo compartir la lectura.');
      setSaveSuccess(null);
    } finally {
      sharingRef.current = false;
    }
  }

  async function handleCopyShareText() {
    try {
      if (!result) return;
      const payload = sharePayload;
      await navigator.clipboard.writeText(payload.shareText);
      setShareModalOpen(false);
      setSaveError(null);
      setSaveSuccess('Texto de la lectura copiado para compartir.');
    } catch (err) {
      setSaveError('No se pudo copiar el texto de la lectura.');
      setSaveSuccess(null);
    }
  }

  async function handleCopyShareLink() {
    try {
      if (!result) return;
      const payload = sharePayload;
      await navigator.clipboard.writeText(payload.appUrl);
      setShareModalOpen(false);
      setSaveError(null);
      setSaveSuccess('Link de Zodiacus copiado al portapapeles.');
    } catch (err) {
      setSaveError('No se pudo copiar el link de la lectura.');
      setSaveSuccess(null);
    }
  }

  function openShareWindow(url, destinationLabel = 'la app seleccionada') {
    if (!url || typeof window === 'undefined') return;
    setShareModalOpen(false);
    setSaveError(null);
    setSaveSuccess(`Abriendo ${destinationLabel} para compartir la lectura…`);
    window.open(url, '_blank', 'noopener,noreferrer,width=720,height=760');
  }

  async function handleDownloadShareCard() {
  try {
    if (!result || typeof window === 'undefined' || typeof document === 'undefined') return;

   const payload = sharePayload;
    setShareCardBusy(true);

    const pngBlob = await renderShareCardPngBlob(payload);
    const objectUrl = URL.createObjectURL(pngBlob);

    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = `zodiacus-compatibilidad-${Date.now()}.png`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(objectUrl);

    setShareModalOpen(false);
    setSaveError(null);
    setSaveSuccess('Card premium descargada con éxito.');
  } catch (err) {
    setSaveError('No se pudo descargar la card premium.');
    setSaveSuccess(null);
  } finally {
    setShareCardBusy(false);
  }
}

 async function handleNativeShareCard() {
  try {
    if (!result || typeof navigator === 'undefined' || typeof navigator.share !== 'function') {
      setSaveError('Tu dispositivo no permite compartir la card visual directamente.');
      setSaveSuccess(null);
      return;
    }

    const payload = sharePayload;
    setShareCardBusy(true);

    const file = await createShareCardFile(payload);
    if (typeof navigator.canShare === 'function' && !navigator.canShare({ files: [file] })) {
      setSaveError('Tu dispositivo no admite compartir esta card visual como archivo.');
      setSaveSuccess(null);
      return;
    }

    await navigator.share({
      title: `Compatibilidad Zodiacus · ${payload.pairLabel}`,
      text: payload.shareText,
      files: [file],
    });

    setShareModalOpen(false);
    setSaveError(null);
    setSaveSuccess('Card premium compartida con éxito.');
  } catch (err) {
    if (err?.name === 'AbortError') return;
    setSaveError('No se pudo compartir la card premium.');
    setSaveSuccess(null);
  } finally {
    setShareCardBusy(false);
  }
}

  async function handleCalculate() {
    const latA = parseOptionalFiniteNumber(personA.lat);
    const lngA = parseOptionalFiniteNumber(personA.lng);
    const tzA = parseOptionalFiniteNumber(personA.timezoneOffsetMinutes);
    const latB = parseOptionalFiniteNumber(personB.lat);
    const lngB = parseOptionalFiniteNumber(personB.lng);
    const tzB = parseOptionalFiniteNumber(personB.timezoneOffsetMinutes);

    if (personA.hasTime && (latA === null || lngA === null || !personA.birthTimezone)) {
      setError('Revisá el lugar de Persona A. Debe incluir coordenadas y una zona horaria válida.');
      return;
    }

    if (personB.hasTime && (latB === null || lngB === null || !personB.birthTimezone)) {
      setError('Revisá el lugar de Persona B. Debe incluir coordenadas y una zona horaria válida.');
      return;
    }

    try {
      setSaveError(null);
      setSaveSuccess(null);
            resetGuidedInterpretationState(null);
      setLoading(true);
      setError(null);
      setResult(null);

      const payloadA = {
        nickname: personA.nickname,
        birthDate: personA.birthDate,
        birthTime: personA.hasTime ? personA.birthTime : null,
        birthCity: personA.hasTime ? personA.birthCity : null,
        birthCountry: personA.hasTime ? personA.birthCountry : null,
        lat: personA.hasTime ? latA : undefined,
        lng: personA.hasTime ? lngA : undefined,
        timezoneOffsetMinutes: personA.hasTime && tzA !== null ? tzA : undefined,
        birthTimezone: personA.hasTime ? personA.birthTimezone : undefined,
      };

      const payloadB = {
        nickname: personB.nickname,
        birthDate: personB.birthDate,
        birthTime: personB.hasTime ? personB.birthTime : null,
        birthCity: personB.hasTime ? personB.birthCity : null,
        birthCountry: personB.hasTime ? personB.birthCountry : null,
        lat: personB.hasTime ? latB : undefined,
        lng: personB.hasTime ? lngB : undefined,
        timezoneOffsetMinutes: personB.hasTime && tzB !== null ? tzB : undefined,
        birthTimezone: personB.hasTime ? personB.birthTimezone : undefined,
      };

      

      const presentationLanguage = isEnglishPresentation() ? 'en' : 'es';

      const data = await postDeepSynastry(
        payloadA,
        payloadB,
        presentationLanguage
      );

      setResult(data);
      setGuidedReading(data);
    } catch (err) {
      setError(err?.message || 'No se pudo calcular la sinastría profunda.');
    } finally {
      setLoading(false);
    }
  }

  function buildSaveFingerprint() {
    const masterScore = Number(result?.compatibility?.masterScore || 0);
    return JSON.stringify({
      aName: String(personA.nickname || '').trim().toLowerCase(),
      aDate: String(personA.birthDate || '').trim(),
      aTime: String(personA.birthTime || '').trim(),
      aCity: String(personA.birthCity || '').trim().toLowerCase(),
      bName: String(personB.nickname || '').trim().toLowerCase(),
      bDate: String(personB.birthDate || '').trim(),
      bTime: String(personB.birthTime || '').trim(),
      bCity: String(personB.birthCity || '').trim().toLowerCase(),
      score: masterScore,
    });
  }

  function buildLocalSavedEntry(apiResponse, baseResult) {
  const savedResult =
    apiResponse?.saved?.resultSnapshot || apiResponse?.result || baseResult || null;

  const compatibility = Number(
    savedResult?.compatibility?.masterScore ||
      baseResult?.compatibility?.masterScore ||
      0
  );

  const attraction = Number(
    savedResult?.dimensions?.attraction?.score || compatibility || 0
  );

  const karmic = Number(
    savedResult?.dimensions?.karmic?.score || compatibility || 0
  );

  const fingerprint = buildSaveFingerprint();

  return {
    id:
      apiResponse?.item?._id ||
      apiResponse?.item?.id ||
      apiResponse?.saved?._id ||
      apiResponse?.saved?.id ||
      fingerprint,
    fingerprint,
    title: `${personA.nickname || 'Persona A'} ✦ ${personB.nickname || 'Persona B'}`,
    personA: {
      name: personA.nickname || 'Persona A',
      nickname: personA.nickname || 'Persona A',
      birthDate: personA.birthDate,
      birthTime: personA.hasTime ? personA.birthTime : '',
      birthCity: personA.hasTime ? personA.birthCity : '',
      birthCountry: personA.hasTime ? personA.birthCountry : '',
      birthPlaceLabel: personA.birthPlaceLabel,
      lat: personA.hasTime ? personA.lat : '',
      lng: personA.hasTime ? personA.lng : '',
      timezoneOffsetMinutes: personA.hasTime ? personA.timezoneOffsetMinutes : '',
      sign:
        savedResult?.metadata?.personA?.sunSign ||
        baseResult?.metadata?.personA?.sunSign ||
        '',
      sunSign:
        savedResult?.metadata?.personA?.sunSign ||
        baseResult?.metadata?.personA?.sunSign ||
        '',
    },
    personB: {
      name: personB.nickname || 'Persona B',
      nickname: personB.nickname || 'Persona B',
      birthDate: personB.birthDate,
      birthTime: personB.hasTime ? personB.birthTime : '',
      birthCity: personB.hasTime ? personB.birthCity : '',
      birthCountry: personB.hasTime ? personB.birthCountry : '',
      birthPlaceLabel: personB.birthPlaceLabel,
      lat: personB.hasTime ? personB.lat : '',
      lng: personB.hasTime ? personB.lng : '',
      timezoneOffsetMinutes: personB.hasTime ? personB.timezoneOffsetMinutes : '',
      sign:
        savedResult?.metadata?.personB?.sunSign ||
        baseResult?.metadata?.personB?.sunSign ||
        '',
      sunSign:
        savedResult?.metadata?.personB?.sunSign ||
        baseResult?.metadata?.personB?.sunSign ||
        '',
    },
    compatibility,
    compatibilityScore: compatibility,
    attraction,
    karmic,
    summary:
      savedResult?.narratives?.overview ||
      baseResult?.narratives?.overview ||
      '',
    overview:
      savedResult?.narratives?.overview ||
      baseResult?.narratives?.overview ||
      '',
    result: savedResult || baseResult,
    savedAt: new Date().toISOString(),
  };
}
    
    async function handleSaveReading() {
    try {
      if (!result) {
        throw new Error('Primero calculá una sinastría antes de guardarla.');
      }

      if (savingRef.current) {
        return;
      }

      const fingerprint = buildSaveFingerprint();

      if (lastSavedFingerprintRef.current && lastSavedFingerprintRef.current === fingerprint) {
        setSaveError(null);
        setSaveSuccess('Esta lectura ya fue guardada recientemente.');
        return;
      }

      savingRef.current = true;
      setSaving(true);
            setSaveError(null);
      setSaveSuccess(null);
      lastSavedFingerprintRef.current = '';

const saveLatA = parseOptionalFiniteNumber(personA.lat);
const saveLngA = parseOptionalFiniteNumber(personA.lng);
const saveTzA = parseOptionalFiniteNumber(personA.timezoneOffsetMinutes);
const saveLatB = parseOptionalFiniteNumber(personB.lat);
const saveLngB = parseOptionalFiniteNumber(personB.lng);
const saveTzB = parseOptionalFiniteNumber(personB.timezoneOffsetMinutes);

if (personA.hasTime && (saveLatA === null || saveLngA === null || saveTzA === null)) {
  throw new Error('Revisá los datos numéricos de Persona A antes de guardar la lectura.');
}

if (personB.hasTime && (saveLatB === null || saveLngB === null || saveTzB === null)) {
  throw new Error('Revisá los datos numéricos de Persona B antes de guardar la lectura.');
}

     const response = await saveDeepSynastry({
  title: `${personA.nickname || 'Persona A'} ✦ ${personB.nickname || 'Persona B'}`,
  personA: {
    nickname: personA.nickname,
    birthDate: personA.birthDate,
    birthTime: personA.hasTime ? personA.birthTime : '',
    birthCity: personA.hasTime ? personA.birthCity : '',
    birthCountry: personA.hasTime ? personA.birthCountry : '',
    birthPlaceLabel: personA.birthPlaceLabel,
    lat: personA.hasTime ? saveLatA : undefined,
    lng: personA.hasTime ? saveLngA : undefined,
    timezoneOffsetMinutes: personA.hasTime ? saveTzA : undefined,
  },
  personB: {
    nickname: personB.nickname,
    birthDate: personB.birthDate,
    birthTime: personB.hasTime ? personB.birthTime : '',
    birthCity: personB.hasTime ? personB.birthCity : '',
    birthCountry: personB.hasTime ? personB.birthCountry : '',
    birthPlaceLabel: personB.birthPlaceLabel,
    lat: personB.hasTime ? saveLatB : undefined,
    lng: personB.hasTime ? saveLngB : undefined,
    timezoneOffsetMinutes: personB.hasTime ? saveTzB : undefined,
  },
  result,
});

      const localEntry = buildLocalSavedEntry(response, result);
      lastSavedFingerprintRef.current = fingerprint;

      const savedTitle = response?.item?.title || response?.saved?.title || localEntry.title || 'Lectura guardada';
      setSaveSuccess(`Compatibilidad guardada con éxito: ${savedTitle}.`);
    } catch (err) {
      setSaveError(err?.message || 'No se pudo guardar la lectura.');
    } finally {
      savingRef.current = false;
      setSaving(false);
    }
  }

  const sharePayload = useMemo(() => {
  return result ? buildSharePayload(result, personA, personB) : null;
}, [result, personA, personB]);
  const gridStyle = isMobile ? styles.gridMobile : styles.grid;
  const chartGridStyle = isMobile ? styles.chartGridMobile : styles.chartGrid;
  const scoreRowStyle = isMobile ? styles.scoreRowMobile : styles.scoreRow;
  
  const techGridStyle = isMobile ? styles.techGridMobile : styles.techGrid;
  const dimGridStyle = isMobile ? styles.dimGridMobile : styles.dimGrid;
  
  const overlayColumnsStyle = isMobile ? styles.overlayColumnsMobile : styles.overlayColumns;
  const actionRowStyle = isMobile ? styles.actionRowMobile : styles.actionRow;
  const shareActionsGridStyle = isMobile ? styles.shareActionsGridMobile : styles.shareActionsGrid;

  const chartCoverageA = result?.metadata?.chartCoverage?.personA;
  const chartCoverageB = result?.metadata?.chartCoverage?.personB;
  const significantAspects = normalizeArray(result?.significantAspects).slice(0, 8);
  const houseOverlays = result?.houseOverlays || null;
  const overlayCoverage = result?.metadata?.houseOverlayCoverage || houseOverlays?.meta || null;
  const houseOverlayHighlights = normalizeArray(result?.narratives?.houseOverlayHighlights || houseOverlays?.highlights).slice(0, 6);
  const overlayDimensions = houseOverlays?.dimensions || {};
  const relationshipStrengths = normalizeArray(result?.strengths).filter(
    (item) => !isRedundantStrengthOverlay(item)
  );

  const personAResolvedPlace = hasResolvedPlace(personA);
  const personBResolvedPlace = hasResolvedPlace(personB);

  return (
    <div
      style={{
        ...styles.wrapper,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
      }}
    >

  {/* Cosmic starfield */}
  {!isMobile ? (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        backgroundImage:
          'radial-gradient(rgba(255,255,255,0.35) 1px, transparent 1px), radial-gradient(rgba(255,255,255,0.18) 1px, transparent 1px)',
        backgroundSize: '3px 3px, 7px 7px',
        backgroundPosition: '0 0, 18px 14px',
        opacity: 0.08,
        zIndex: 0,
      }}
    />
  ) : null}
     <div style={isMobile ? { ...styles.intro, display: 'none' } : styles.intro}>
  <div
    aria-hidden
    style={{
      position: 'absolute',
      inset: 'auto -60px -70px auto',
      width: 220,
      height: 220,
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(247,215,116,0.18) 0%, rgba(247,215,116,0) 70%)',
      filter: isMobile ? 'none' : 'blur(6px)',
      opacity: 0.6,
      pointerEvents: 'none',
      touchAction: 'pan-y',
      zIndex: 0,
    }}
  />
  <div
    aria-hidden
    style={{
      position: 'absolute',
      inset: '-40px auto auto -50px',
      width: 180,
      height: 180,
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(138,43,226,0.18) 0%, rgba(138,43,226,0) 72%)',
      filter: isMobile ? 'none' : 'blur(6px)',
      opacity: 0.5,
      pointerEvents: 'none',
      touchAction: 'pan-y',
      zIndex: 0,
    }}
  />
        <div style={{ position: 'relative', zIndex: 1, pointerEvents: 'none', userSelect: 'none' }}>
          <h2 style={styles.introTitle}>{synText('Sinastría profunda', 'Deep synastry')}</h2>
          <p style={styles.introText}>
            {synText('Ingresá la fecha de nacimiento de ambas personas y, si conocés la hora, agregala junto con ciudad y país. Con esos datos Zodiacus calcula posiciones planetarias reales usando Swiss Ephemeris, detecta aspectos dominantes, analiza resonancia emocional, atracción, estabilidad y cruces de casas. El resultado es una lectura relacional profunda diseñada para revelar la dinámica energética real entre dos cartas natales.', 'Enter both birth dates and, when known, add the times, cities, and countries. Zodiacus uses Swiss Ephemeris to calculate real planetary positions, detect dominant aspects, and analyze emotional resonance, attraction, stability, and house overlays. The result is a deep relationship reading of the true energy between two natal charts.')}
          </p>
        </div>
      </div>

      {!isMobile ? (
        <div
          aria-hidden
          style={{
            position: 'absolute',
            inset: 'auto -90px -90px auto',
            width: 240,
            height: 240,
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(138,43,226,0.20) 0%, rgba(138,43,226,0) 72%)',
            filter: 'none',
            pointerEvents: 'none',
          }}
        />
      ) : null}

      <div style={styles.card}>
        <div style={gridStyle}>
          {['A', 'B'].map((which) => {
            const person = which === 'A' ? personA : personB;
            const resolved = which === 'A' ? personAResolvedPlace : personBResolvedPlace;
            const showTech = which === 'A' ? showTechA : showTechB;
            const setShowTech = which === 'A' ? setShowTechA : setShowTechB;
            const placeEditUnlocked = which === 'A' ? placeEditUnlockedA : placeEditUnlockedB;
            const latPlaceholder = which === 'A' ? 'Ej: -34.6037' : 'Ej: -31.4201';
            const lngPlaceholder = which === 'A' ? 'Ej: -58.3816' : 'Ej: -64.1888';

            return (
              <div
  key={which}
  style={styles.profileCard}
  onMouseEnter={(e) => {
    e.currentTarget.style.transform = 'translateY(-4px)';
    e.currentTarget.style.boxShadow = '0 28px 64px rgba(0,0,0,0.48), 0 0 28px rgba(138,43,226,0.28)';
    e.currentTarget.style.borderColor = 'rgba(247,215,116,0.46)';
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.transform = 'translateY(0)';
    e.currentTarget.style.boxShadow = '0 18px 48px rgba(0,0,0,0.38), inset 0 1px 0 rgba(255,255,255,0.07)';
    e.currentTarget.style.borderColor = 'rgba(247,215,116,0.34)';
  }}
>
                <h3 style={styles.profileHeader}>
                  {which === 'A'
                    ? synText('Persona A', 'Person A')
                    : synText('Persona B', 'Person B')}
                </h3>
<div style={styles.fieldWrap}>
  <label htmlFor={`deep-${which}-nickname`} style={styles.label}>
    {synText('Nombre o apodo', 'Name or nickname')}
  </label>
  <input
    id={`deep-${which}-nickname`}
    name={`deep_${which}_nickname`}
    autoComplete="off"
    style={styles.input}
    value={person.nickname}
    onChange={(e) => updatePerson(which, 'nickname', e.target.value)}
  />
</div>
<div style={styles.fieldWrap}>
  <label htmlFor={`deep-${which}-birthDate`} style={styles.label}>
    {synText('Fecha de nacimiento', 'Birth date')}
  </label>
  <input
    id={`deep-${which}-birthDate`}
    name={`deep_${which}_birthDate`}
    type="date"
    style={styles.input}
    value={person.birthDate}
    onChange={(e) => updatePerson(which, 'birthDate', e.target.value)}
  />
</div>
<label htmlFor={`deep-${which}-hasTime`} style={styles.checkboxRow}>
  <input
    id={`deep-${which}-hasTime`}
    name={`deep_${which}_hasTime`}
    type="checkbox"
    checked={person.hasTime}
    onChange={(e) => toggleHasTime(which, e.target.checked)}
  />
  {synText(
    'Conozco la hora de nacimiento',
    'I know the exact birth time'
  )}
</label>

{person.hasTime ? (
  <>
    <div style={styles.fieldWrap}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)',
          gap: 10,
          marginBottom: 6,
        }}
      >
        <span style={styles.label}>
          {synText('Hora', 'Hour')}
        </span>
        <span
          style={{
            ...styles.label,
            fontSize: 11,
            textTransform: 'uppercase',
            opacity: 0.8,
          }}
        >
          {synText('Minutos', 'Minutes')}
        </span>
      </div>

      <div style={{ position: 'relative', display: 'grid', gap: 8 }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)', gap: 10 }}>
          <div>
            <div style={{ position: 'relative' }}>
              <select
                id={`deep-${which}-birthHour`}
                name={`deep_${which}_birthHour`}
                value={String(person.birthTimeHour || String(person.birthTime || '').match(/^(\d{2}):(\d{2})$/)?.[1] || '')}
                onChange={(e) => {
                  const nextHour = String(e.target.value || '').trim();
                  const currentMinute = String(person.birthTimeMinute || String(person.birthTime || '').match(/^(\d{2}):(\d{2})$/)?.[2] || '');
                  updatePerson(which, 'birthTimeHour', nextHour);
                  updatePerson(which, 'birthTime', nextHour && currentMinute ? `${nextHour}:${currentMinute}` : '');
                }}
                style={{
                  width: '100%',
                  height: 54,
                  borderRadius: 16,
                  border: '1px solid rgba(247,215,116,0.30)',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%), linear-gradient(135deg, rgba(75,0,130,0.22) 0%, rgba(16,10,28,0.94) 72%, rgba(218,165,32,0.12) 100%)',
                  color: '#FFF3C4',
                  padding: '0 50px 0 14px',
                  fontSize: 15,
                  fontWeight: 800,
                  outline: 'none',
                  boxSizing: 'border-box',
                  boxShadow:
                    '0 14px 34px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.06)',
                  appearance: 'none',
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  cursor: 'pointer',
                }}
              >
                <option value="">
                  {synText('Hora', 'Hour')}
                </option>
                {Array.from({ length: 24 }, (_, index) => {
                  const hour = String(index).padStart(2, '0');
                  return (
                    <option key={`${which}-hour-${hour}`} value={hour}>
                      {hour}
                    </option>
                  );
                })}
              </select>
              <div
                aria-hidden
                style={{
                  position: 'absolute',
                  right: 14,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  width: 26,
                  height: 26,
                  borderRadius: 999,
                  display: 'grid',
                  placeItems: 'center',
                  color: '#F7D774',
                  fontSize: 12,
                  fontWeight: 900,
                  background:
                    'linear-gradient(180deg, rgba(247,215,116,0.16) 0%, rgba(247,215,116,0.06) 100%)',
                  border: '1px solid rgba(247,215,116,0.18)',
                }}
              >
                ▾
              </div>
            </div>
          </div>

          <div>
            <div style={{ position: 'relative' }}>
              <select
                id={`deep-${which}-birthMinute`}
                name={`deep_${which}_birthMinute`}
                value={String(person.birthTimeMinute || String(person.birthTime || '').match(/^(\d{2}):(\d{2})$/)?.[2] || '')}
                onChange={(e) => {
                  const nextMinute = String(e.target.value || '').trim();
                  const currentHour = String(person.birthTimeHour || String(person.birthTime || '').match(/^(\d{2}):(\d{2})$/)?.[1] || '');
                  updatePerson(which, 'birthTimeMinute', nextMinute);
                  updatePerson(which, 'birthTime', currentHour && nextMinute ? `${currentHour}:${nextMinute}` : '');
                }}
                style={{
                  width: '100%',
                  height: 54,
                  borderRadius: 16,
                  border: '1px solid rgba(247,215,116,0.30)',
                  background:
                    'linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.03) 100%), linear-gradient(135deg, rgba(75,0,130,0.22) 0%, rgba(16,10,28,0.94) 72%, rgba(218,165,32,0.12) 100%)',
                  color: '#FFF3C4',
                  padding: '0 50px 0 14px',
                  fontSize: 15,
                  fontWeight: 800,
                  outline: 'none',
                  boxSizing: 'border-box',
                  boxShadow:
                    '0 14px 34px rgba(0,0,0,0.22), inset 0 1px 0 rgba(255,255,255,0.06)',
                  appearance: 'none',
                  WebkitAppearance: 'none',
                  MozAppearance: 'none',
                  cursor: 'pointer',
                }}
              >
                <option value="">Min</option>
                {Array.from({ length: 60 }, (_, index) => {
                  const minute = String(index).padStart(2, '0');
                  return (
                    <option key={`${which}-minute-${minute}`} value={minute}>
                      {minute}
                    </option>
                  );
                })}
              </select>
              <div
                aria-hidden
                style={{
                  position: 'absolute',
                  right: 14,
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  width: 26,
                  height: 26,
                  borderRadius: 999,
                  display: 'grid',
                  placeItems: 'center',
                  color: '#F7D774',
                  fontSize: 12,
                  fontWeight: 900,
                  background:
                    'linear-gradient(180deg, rgba(247,215,116,0.16) 0%, rgba(247,215,116,0.06) 100%)',
                  border: '1px solid rgba(247,215,116,0.18)',
                }}
              >
                ▾
              </div>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span
            style={{
              padding: '3px 10px',
              borderRadius: 999,
              border: '1px solid rgba(218,165,32,0.2)',
              fontSize: 11,
              fontWeight: 800,
              color: '#FFF3C4',
            }}
          >
            Formato 24h
          </span>

          <span style={{ fontSize: 12, color: 'rgba(255,243,196,0.6)' }}>
            Hora y minutos exactos · 00–23 / 00–59
          </span>
        </div>
      </div>
    </div>
      <div style={styles.fieldWrap}>
      <div style={styles.fieldHeaderRow}>
        {placeEditUnlocked || !person.birthCity ? (
  <label htmlFor={`deep-${which}-birthCity`} style={styles.label}>
    Ciudad
  </label>
) : (
  <span style={styles.label}>Ciudad</span>
)}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          {resolved ? <span style={styles.fieldPill}>Lugar resuelto</span> : null}
          {!placeEditUnlocked && person.birthCity ? (
            <button
              type="button"
              style={styles.inlineGhostButton}
              onClick={() => {
                if (which === 'A') setPlaceEditUnlockedA(true);
                else setPlaceEditUnlockedB(true);
              }}
            >
              Editar ciudad
            </button>
          ) : null}
        </div>
      </div>

      {!placeEditUnlocked && person.birthCity ? (
        <button
          type="button"
          style={styles.lockedPlaceButton}
          onClick={() => {
            if (which === 'A') setPlaceEditUnlockedA(true);
            else setPlaceEditUnlockedB(true);
          }}
        >
          {person.birthCity}
        </button>
      ) : (
        <PlaceAutocomplete
          value={person.birthCity}
          inputId={`deep-${which}-birthCity`}
          inputName={`deep_${which}_birthCity`}
          label="Ciudad de nacimiento"
          onInputChange={(nextValue) => handlePlaceInput(which, nextValue)}
          onSelectPlace={(place) => handlePlaceSelect(which, place)}
          placeholder={synText('Elegí o escribí una ciudad', 'Choose or enter a city')}
          hint={person.birthCity ? '' : 'Escribí al menos 2 letras para ver sugerencias reales.'}
        />
      )}
    </div>
    {resolved ? (
      <div style={styles.selectedPlaceCard}>
        <p style={styles.selectedPlaceTitle}>{person.birthCity}</p>
        <p style={styles.selectedPlaceMeta}>{getResolvedPlaceRegion(person)}</p>
        <div style={styles.selectedPlaceSummary}>
          <span style={styles.fieldPill}>{synText('Ubicación verificada', 'Location verified')}</span>
          <span style={styles.fieldPill}>{synText('Zona horaria resuelta', 'Time zone resolved')}</span>
        </div>
        <button type="button" style={styles.techToggle} onClick={() => setShowTech((prev) => !prev)}>
          {showTech ? 'Ocultar detalles técnicos' : 'Ver detalles técnicos'}
        </button>
        {showTech ? (
          <div style={styles.techPanel}>
            <div style={techGridStyle}>
              <div style={styles.techStat}><p style={styles.techStatLabel}>Latitud</p><p style={styles.techStatValue}>{formatTechValue(person.lat)}</p></div>
              <div style={styles.techStat}><p style={styles.techStatLabel}>Longitud</p><p style={styles.techStatValue}>{formatTechValue(person.lng)}</p></div>
              <div style={styles.techStat}><p style={styles.techStatLabel}>Zona IANA</p><p style={styles.techStatValue}>{formatTechValue(person.birthTimezone)}</p></div>
              <div style={styles.techStat}><p style={styles.techStatLabel}>UTC offset</p><p style={styles.techStatValue}>{formatTechValue(person.timezoneOffsetMinutes)}</p></div>
            </div>
          </div>
        ) : null}
      </div>
    ) : null}
    <div style={styles.fieldWrap}>
      <label htmlFor={`deep-${which}-birthCountry`} style={styles.label}>{synText('País', 'Country')}</label>
      <input
        id={`deep-${which}-birthCountry`}
        name={`deep_${which}_birthCountry`}
        autoComplete="country-name"
        style={{ ...styles.input, ...(resolved ? styles.readonlyInput : null) }}
        value={person.birthCountry}
        onChange={(e) => updatePerson(which, 'birthCountry', e.target.value)}
        readOnly={resolved}
      />
    </div>
    <div style={styles.fieldWrap}>
      <label htmlFor={`deep-${which}-lat`} style={styles.label}>Latitud (opcional)</label>
      <input
        id={`deep-${which}-lat`}
        name={`deep_${which}_lat`}
        type="number"
        step="any"
        style={{ ...styles.input, ...(resolved ? styles.readonlyInput : null) }}
        value={person.lat}
        onChange={(e) => updatePerson(which, 'lat', e.target.value)}
        placeholder={latPlaceholder}
        readOnly={resolved}
      />
    </div>
    <div style={styles.fieldWrap}>
      <label htmlFor={`deep-${which}-lng`} style={styles.label}>Longitud (opcional)</label>
      <input
        id={`deep-${which}-lng`}
        name={`deep_${which}_lng`}
        type="number"
        step="any"
        style={{ ...styles.input, ...(resolved ? styles.readonlyInput : null) }}
        value={person.lng}
        onChange={(e) => updatePerson(which, 'lng', e.target.value)}
        placeholder={lngPlaceholder}
        readOnly={resolved}
      />
    </div>
    <div style={styles.fieldWrap}>
      <label htmlFor={`deep-${which}-timezoneOffsetMinutes`} style={styles.label}>UTC offset en minutos (opcional)</label>
      <input
        id={`deep-${which}-timezoneOffsetMinutes`}
        name={`deep_${which}_timezoneOffsetMinutes`}
        type="number"
        step="1"
        style={styles.input}
        value={person.timezoneOffsetMinutes}
        onChange={(e) => updatePerson(which, 'timezoneOffsetMinutes', e.target.value)}
        placeholder="Ej: -180"
      />
    </div>
  </>
                ) : (
                  <div style={styles.helper}>
                    {which === 'A'
                      ? <>{synText('Sin hora exacta, la lectura sigue siendo útil, pero algunas posiciones como Luna y Ascendente pueden quedar parciales o no disponibles.', 'Without an exact time, the reading is still useful, but placements such as the Moon and Ascendant may be partial or unavailable.')} <span style={styles.helperStrong}>{synText('La hora mejora mucho la precisión profunda.', 'The birth time greatly improves deep-reading accuracy.')}</span></>
                      : <>{synText('También podés calcular una lectura parcial solo con fecha. Después, si conseguís la hora, la completamos.', 'You can calculate a partial reading using dates only, then complete it later when you have the times.')} <span style={styles.helperStrong}>{synText('La versión más fuerte siempre aparece con ambos horarios.', 'The most precise version uses both birth times.')}</span></>}
                  </div>
                )}
              </div>
            );
          })}
        </div>

    <div style={actionRowStyle}>
      <button
        type="button"
        onClick={handleCalculate}
        disabled={!canSubmit}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-3px)';
          e.currentTarget.style.boxShadow = '0 26px 60px rgba(218,165,32,0.34), 0 0 26px rgba(247,215,116,0.25)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 20px 42px rgba(218,165,32,0.28)';
        }}
        style={{
          ...styles.button,
          width: isMobile ? '100%' : 'auto',
          justifyContent: 'center',
          ...((!canSubmit || loading) ? styles.buttonDisabled : null),
        }}
      >
        {loading
          ? synText('Calculando sinastría…', 'Calculating synastry…')
          : synText('Calcular sinastría completa', 'Calculate full synastry')}
      </button>

      <button
        type="button"
        onClick={handleOpenCosmicLibrary}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = '0 18px 40px rgba(0,0,0,0.35), 0 0 20px rgba(138,43,226,0.25)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 12px 28px rgba(0,0,0,0.28)';
        }}
        style={{
          ...styles.secondaryButton,
          width: isMobile ? '100%' : 'auto',
        }}
      >
        {synText('Biblioteca cósmica', 'Cosmic Library')}
      </button>

      <div style={{ ...styles.subNote, flex: 1, minWidth: isMobile ? '100%' : 260 }}>
        {loading
          ? synText(
              'Calculando posiciones planetarias, aspectos, confiabilidad y cruces de casas…',
              'Calculating planetary positions, aspects, reliability, and house overlays…'
            )
          : synText(
              'Podés calcular una nueva lectura o entrar directamente a tu biblioteca cósmica para revisar sinastrías guardadas.',
              'You can calculate a new reading or open your Cosmic Library to review saved synastries.'
            )}
      </div>
    </div>
  </div>

  {error ? <div style={styles.error}>{error}</div> : null}
  {saveError ? <div style={styles.error}>{saveError}</div> : null}
  {saveSuccess ? <div style={styles.successBox}>{saveSuccess}</div> : null}

  {result ? (
        <div
          style={{
            ...styles.resultCard,
            height: 'auto',
            minHeight: 'unset',
            maxHeight: 'none',
            alignSelf: 'flex-start',
            flex: '0 0 auto',
          }}
        >
          <div
  aria-hidden
  style={{
    position: 'absolute',
    top: -40,
    right: -40,
    width: 220,
    height: 220,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(247,215,116,0.16) 0%, rgba(247,215,116,0) 72%)',
    filter: 'none',
    pointerEvents: 'none',
  }}
/>
<div
  aria-hidden
  style={{
    position: 'absolute',
    left: -60,
    bottom: -60,
    width: 240,
    height: 240,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(138,43,226,0.18) 0%, rgba(138,43,226,0) 72%)',
    filter: 'none',
    pointerEvents: 'none',
  }}
/>
      <div
        style={{
          marginTop: 12,
          marginBottom: 12,
          borderRadius: 18,
          padding: 12,
          border: '1px solid rgba(218,165,32,0.18)',
          background: 'linear-gradient(135deg, rgba(75,0,130,0.25) 0%, rgba(20,12,38,0.95) 100%)',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 8,
          justifyContent: 'space-between',
          alignItems: 'center',
          pointerEvents: 'auto',
          position: 'relative',
          zIndex: 2,
          isolation: 'isolate',
        }}
      >
        <div style={{ display: 'grid', gap: 3, minWidth: isMobile ? '100%' : 250 }}>
          <strong style={{ color: '#FFF3C4', fontSize: 13 }}>
            {synText('Explorá otra conexión cósmica', 'Explore another cosmic connection')}
          </strong>
          <span style={{ color: 'rgba(255,243,196,0.72)', fontSize: 11, lineHeight: 1.45 }}>
            {synText('Compará esta lectura con otra sinastría guardada y descubrí qué vínculo tiene más atracción, estabilidad, resonancia emocional o potencial real.', 'Compare this reading with another saved synastry to discover which connection has greater attraction, stability, emotional resonance, or long-term potential.')}
          </span>
        </div>

        <div
          style={{
            ...actionRowStyle,
            flex: 1,
            minWidth: isMobile ? '100%' : 360,
            marginBottom: 0,
            gap: 8,
            pointerEvents: 'auto',
            position: 'relative',
            zIndex: 3,
            isolation: 'isolate',
          }}
        >
          <button
            type="button"
            onClick={handleSaveReading}
            disabled={saving || loading || !result}
            style={{
              ...styles.secondaryButton,
              flex: 1,
              minWidth: isMobile ? '100%' : 180,
              ...((saving || loading || !result) ? styles.buttonDisabled : null),
            }}
          >
            {saving
              ? synText('Guardando lectura…', 'Saving reading…')
              : synText('Guardar lectura', 'Save reading')}
          </button>

          <button
            type="button"
            onMouseDown={handleOpenSynastryComparison}
            onClick={handleOpenSynastryComparison}
            style={{
              ...styles.secondaryButton,
              flex: 1,
              minWidth: isMobile ? '100%' : 180,
              pointerEvents: 'auto',
              position: 'relative',
              zIndex: 4,
              isolation: 'isolate',
            }}
          >
            {synText('Comparar 2 lecturas', 'Compare 2 readings')}
          </button>

          <button
            type="button"
            onClick={handleShareReading}
            style={{
              ...styles.secondaryButton,
              flex: 1,
              minWidth: isMobile ? '100%' : 180,
            }}
          >
            {synText('Compartir lectura', 'Share reading')}
          </button>
        </div>
      </div>

      {result.reliability ? (() => {
        const missingElements = normalizeArray(result.reliability.missingElements);
        const hasMissingElements = missingElements.length > 0;
        const reliabilityPct = Math.round(Number(result.reliability.score || 0) * 100);
        const tierLabel = result.metadata?.calculationTier
          ? formatCalculationTier(result.metadata.calculationTier)
          : '';

        if (!hasMissingElements) {
          return (
            <div style={styles.reliabilityCompact}>
              <div style={styles.reliabilityCompactLead}>
                <span style={styles.reliabilityCompactCheck} aria-hidden="true">✓</span>
                <div style={{ minWidth: 0 }}>
                  <p style={styles.reliabilityCompactTitle}>
                    {synText('Lectura de alta precisión', 'High-precision reading')}
                  </p>
                  <p style={styles.reliabilityCompactMeta}>
                    {[
                      `${reliabilityPct}%`,
                      tierLabel,
                    ].filter(Boolean).join(' · ')}
                  </p>
                </div>
              </div>
            </div>
          );
        }

        return (
          <div style={styles.reliability}>
            <div style={styles.reliabilityHeader}>
              <h3 style={{ ...styles.sectionTitle, marginBottom: 0 }}>
                {localizeNarrativeText(result.reliability.label) || synText('Confiabilidad de la lectura', 'Reading reliability')}
              </h3>

              <div style={styles.reliabilityMeta}>
                <span style={styles.microBadge}>
                  {synText('Confiabilidad', 'Reliability')} {reliabilityPct}%
                </span>

                {tierLabel ? (
                  <span style={styles.microBadge}>
                    {tierLabel}
                  </span>
                ) : null}
              </div>
            </div>

            {result.reliability.explanation ? (
              <p style={styles.text}>
                {localizeNarrativeText(result.reliability.explanation)}
              </p>
            ) : null}

            <div style={styles.missingWrap}>
              {missingElements.slice(0, 4).map((item, idx) => (
                <div key={`missing-${idx}`} style={styles.missingItem}>
                  <p style={styles.missingTitle}>
                    {localizeNarrativeText(item.reason) || synText('Dato faltante', 'Missing data')}
                  </p>
                  {item.impact ? (
                    <p style={styles.missingMeta}>
                      {localizeNarrativeText(item.impact)}
                    </p>
                  ) : null}
                  {item.workaround ? (
                    <p style={{ ...styles.missingMeta, color: 'rgba(247,215,116,0.82)' }}>
                      {localizeNarrativeText(item.workaround)}
                    </p>
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        );
      })() : null}

          <div style={scoreRowStyle}>
            <div style={styles.scoreBox}>
              <p style={styles.scoreLabel}>{synText('Compatibilidad Sinástrica', 'Synastry Compatibility')}</p>
              <div style={{ display: 'grid', gap: 12, marginTop: 18 }}>
                {(() => {
                  const score = Number(result.compatibility?.masterScore || 0);
                  const profile = getRelationshipProfile(score);
                  const visual = getCompatibilityVisualProfile(score);

                  const nameA = localizeGenericPersonName(
                    result?.metadata?.personA?.nickname || 'Persona A'
                  );
                  const nameB = localizeGenericPersonName(
                    result?.metadata?.personB?.nickname || 'Persona B'
                  );
                  const signA = localizeSynastryDisplayValue(
                    result?.metadata?.personA?.sunSign || ''
                  );
                  const signB = localizeSynastryDisplayValue(
                    result?.metadata?.personB?.sunSign || ''
                  );

                  const identityA = signA ? `${nameA} · ${signA}` : nameA;
                  const identityB = signB ? `${nameB} · ${signB}` : nameB;

                  return (
                    <>
                      <div style={styles.primaryPairRow}>
                        <span style={styles.primaryPairName}>{identityA}</span>
                        <span style={styles.primaryPairDivider} aria-hidden="true">✦</span>
                        <span style={styles.primaryPairName}>{identityB}</span>
                      </div>

                      <div style={styles.scoreGaugeWrap}>
                        <div
                          style={{
                            ...styles.scoreGaugeRing,
                            background: visual.ring,
                            boxShadow: `${styles.scoreGaugeRing.boxShadow}, ${visual.glow}`,
                          }}
                        >
                          <div style={styles.scoreGaugeInner}>
                            <p style={styles.scoreGaugeLabel}>
                              {synText('Compatibilidad', 'Compatibility')}
                            </p>
                            <div style={styles.scoreGaugeValue}>{score || '—'}%</div>
                          </div>
                        </div>
                      </div>

                      <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <span style={styles.primaryRelationshipLabel}>✦ {profile.label}</span>
                      </div>

                      <div style={styles.primarySummaryPills}>
                        {profile.bullets.map((bullet, index) => (
                          <span key={`summary-${index}`} style={styles.primarySummaryPill}>
                            {bullet}
                          </span>
                        ))}
                      </div>
                    </>
                  );
                })()}
              </div>
            </div>
            <div style={styles.overviewCard}>
  <div aria-hidden style={styles.overviewGlowA} />
  <div aria-hidden style={styles.overviewGlowB} />

  <div style={styles.overviewHeader}>
    <h3 style={styles.overviewTitle}>{synText('Visión general', 'Overview')}</h3>
    <div style={styles.overviewSignRow}>
      {result.metadata?.personA?.sunSign ? (
        <span style={styles.overviewSignPill}>
          {localizeSynastryDisplayValue(result.metadata.personA.sunSign)}
        </span>
      ) : null}
      {result.metadata?.personB?.sunSign ? (
        <span style={styles.overviewSignPill}>
          {localizeSynastryDisplayValue(result.metadata.personB.sunSign)}
        </span>
      ) : null}
    </div>
  </div>

<p style={styles.overviewNarrative}>
  {renderHighlightedOverviewText(
    localizeNarrativeText(completeLegacyTruncatedOverview(result?.narratives?.overview)) || synText('Sin resumen disponible.', 'No summary is available.'),
    [
      getBestExplicitName(personA, result?.metadata?.personA, 'Persona A'),
      getBestExplicitName(personB, result?.metadata?.personB, 'Persona B'),
    ]
  )}
              </p>
              
</div>
          </div>

          <div style={chartGridStyle}>
            <PlanetList title={result.metadata?.personA?.nickname || 'Persona A'} chart={result.charts?.personA} coverageLabel={formatCoverageLabel(chartCoverageA)} />
            <PlanetList title={result.metadata?.personB?.nickname || 'Persona B'} chart={result.charts?.personB} coverageLabel={formatCoverageLabel(chartCoverageB)} />
          </div>

         {significantAspects.length ? (
  <SectionFrame title={null} right={null}>
    <div style={styles.dominantAspectsCard}>
      <div aria-hidden style={styles.dominantAspectsGlowA} />
      <div aria-hidden style={styles.dominantAspectsGlowB} />

      <div style={styles.dominantAspectsHeader}>
        <h3 style={styles.dominantAspectsTitle}>{synText('Aspectos dominantes', 'Key aspects')}</h3>
        <div style={styles.dominantAspectsMetaRow}>
          <span style={styles.microBadge}>{synText(`${significantAspects.length} destacados`, `${significantAspects.length} highlights`)}</span>
        </div>
      </div>

     <div style={isMobile ? styles.dominantAspectsBodyMobile : styles.dominantAspectsBody}>
        {significantAspects.map((item) => (
          <div key={`aspect-${item.rank}`} style={styles.dominantAspectPremiumItem}>
            <div style={styles.dominantAspectPremiumTop}>
              <span style={styles.dominantAspectPremiumDot} />
              <p style={styles.dominantAspectPremiumTitle}>
                {localizeDisplayedAspectText(item.interpretation)}
              </p>
            </div>

            <p style={styles.dominantAspectPremiumMeta}>
              {formatAspectMeta(item)}
            </p>
          </div>
        ))}
      </div>
    </div>
  </SectionFrame>
) : null}

          {houseOverlayHighlights.length ? (
            <SectionFrame title={null} right={null}>
              <div style={styles.overlayHighlightsCard}>
                <div aria-hidden style={styles.overlayHighlightsGlowA} />
                <div aria-hidden style={styles.overlayHighlightsGlowB} />

                <div style={styles.overlayHighlightsHeader}>
                  <h3 style={styles.overlayHighlightsTitle}>
                    {synText(
                      'Cruces destacados entre casas',
                      'Highlighted house overlays'
                    )}
                  </h3>
                  <div style={styles.overlayHighlightsMetaRow}>
                    {overlayCoverage?.source ? (
                      <span style={styles.microBadge}>{formatOverlaySource(overlayCoverage.source)}</span>
                    ) : null}
                    {Number.isFinite(Number(overlayCoverage?.total)) ? (
                      <span style={styles.microBadge}>
                        {synText(
                          `${overlayCoverage.total} cruces de casas`,
                          `${overlayCoverage.total} house overlays`
                        )}
                      </span>
                    ) : null}
                  </div>
                </div>

                <div style={styles.overlayHighlightsBody}>
                  {houseOverlayHighlights.map((item, idx) => (
                    <div key={`highlight-${idx}`} style={styles.overlayHighlightsItem}>
                      <div style={styles.overlayHighlightsItemTop}>
                        <span style={styles.overlayHighlightsDot} />
                        <p style={styles.overlayHighlightsItemTitle}>
                          {localizeOverlayText(item.summaryText || item)}
                        </p>
                      </div>
                      {item.interpretation ? (() => {
                        const compactInterpretation = compactRepeatedNarrativeLead(
                          localizeOverlayText(item.summaryText || item),
                          localizeNarrativeText(item.interpretation)
                        );

                        return compactInterpretation ? (
                          <p style={styles.overlayHighlightsItemText}>
                            {compactInterpretation}
                          </p>
                        ) : null;
                      })() : null}
                    </div>
                  ))}
                </div>
              </div>
            </SectionFrame>
          ) : null}

          {result.dimensions ? (
            <SectionFrame title={synText('Dimensiones profundas', 'Deep dimensions')} right={<span style={styles.microBadge}>{synText('Aspectos + cruces de casas', 'Aspects + house overlays')}</span>}>
              <div style={dimGridStyle}>
                {Object.entries(result.dimensions).map(([key, value]) => (
                  <DimensionCard key={key} label={presentationLabel(DIMENSION_LABELS, DIMENSION_LABELS_EN, key)} data={value} />
                ))}
              </div>
            </SectionFrame>
          ) : null}

          {houseOverlays ? (
            <SectionFrame title={synText('Planetas en las casas del otro', 'Planets in each other\'s houses')} right={<span style={styles.microBadge}>{synText('Cruces de casas premium', 'Premium house overlays')}</span>}>
              <div style={overlayColumnsStyle}>
                <OverlayDirectionalColumn title={buildOverlayDirectionTitle(houseOverlays.personAToPersonB?.sourceName || 'Persona A', houseOverlays.personAToPersonB?.targetName || 'Persona B')} data={houseOverlays.personAToPersonB} />
                <OverlayDirectionalColumn title={buildOverlayDirectionTitle(houseOverlays.personBToPersonA?.sourceName || 'Persona B', houseOverlays.personBToPersonA?.targetName || 'Persona A')} data={houseOverlays.personBToPersonA} />
              </div>
            </SectionFrame>
          ) : null}

          {Object.keys(overlayDimensions || {}).some((key) => normalizeArray(overlayDimensions[key]).length) ? (
            <SectionFrame title={synText('Cruces por dimensión', 'Overlays by dimension')} right={<span style={styles.microBadge}>{synText('Lectura fina', 'Detailed reading')}</span>}>
              <p
                style={{
                  margin: '2px 0 14px',
                  color: 'rgba(255,243,196,0.62)',
                  fontSize: 11,
                  lineHeight: 1.45,
                }}
              >
                {synText(
                  'Resumen por dimensión · el detalle completo de cada cruce está arriba.',
                  'Summary by dimension · the full detail for each overlay appears above.'
                )}
              </p>

              <div style={dimGridStyle}>
                {Object.entries(overlayDimensions).filter(([, items]) => normalizeArray(items).length).map(([key, items]) => (
                  <div key={`overlay-dim-${key}`} style={styles.chartCard}>
                    <div style={styles.reliabilityHeader}>
                      <h3 style={{ ...styles.sectionTitle, marginBottom: 0 }}>{presentationLabel(OVERLAY_DIMENSION_LABELS, OVERLAY_DIMENSION_LABELS_EN, key)}</h3>
                      <span style={styles.microBadge}>
                        {synText(
                          `${items.length} focos`,
                          `${items.length} highlights`
                        )}
                      </span>
                    </div>
                    <div style={styles.overlayList}>
                      {items.slice(0, 3).map((item, idx) => (
                        <div
                          key={`${key}-${idx}`}
                          style={{ ...styles.overlayItem, padding: '14px 16px' }}
                        >
                          <p style={styles.overlayItemTitle}>
                            {renderHighlightedOverlayText(
                              localizeOverlayText(item.summaryText || ''),
                              [
                                getBestExplicitName(personA, result?.metadata?.personA, 'Persona A'),
                                getBestExplicitName(personB, result?.metadata?.personB, 'Persona B'),
                              ],
                              [
                                'Sol',
                                'Luna',
                                'Mercurio',
                                'Venus',
                                'Marte',
                                'Júpiter',
                                'Saturno',
                                'Urano',
                                'Neptuno',
                                'Plutón',
                                'Nodo Norte',
                                'Nodo Sur',
                                'Ascendente',
                                'Descendente',
                                'Casa 1',
                                'Casa 2',
                                'Casa 3',
                                'Casa 4',
                                'Casa 5',
                                'Casa 6',
                                'Casa 7',
                                'Casa 8',
                                'Casa 9',
                                'Casa 10',
                                'Casa 11',
                                'Casa 12',
                              ]
                            )}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </SectionFrame>
          ) : null}

          {(relationshipStrengths.length || normalizeArray(result.challenges).length || normalizeArray(result.advice).length) ? (
            <div style={styles.relationshipGuidanceCard}>
              <div aria-hidden style={styles.relationshipGuidanceGlowA} />
              <div aria-hidden style={styles.relationshipGuidanceGlowB} />

              <div style={styles.relationshipGuidanceHeader}>
                <div>
                  <p style={styles.relationshipGuidanceEyebrow}>
                    {synText('✦ Lectura práctica del vínculo', '✦ Practical relationship reading')}
                  </p>
                  <h3 style={styles.relationshipGuidanceTitle}>
                    {synText(
                      'Lo mejor, lo desafiante y cómo hacerlo crecer',
                      'Strengths, challenges, and how to grow it'
                    )}
                  </h3>
                </div>

                <span style={styles.insightPanelBadge}>
                  {synText('Síntesis premium', 'Premium synthesis')}
                </span>
              </div>

              <div
                style={
                  isMobile
                    ? styles.relationshipGuidanceGridMobile
                    : styles.relationshipGuidanceGrid
                }
              >
                {relationshipStrengths.length ? (
                  <div style={styles.relationshipGuidanceSection}>
                    <div style={styles.relationshipGuidanceSectionHeader}>
                      <span style={styles.relationshipGuidanceSectionIcon} aria-hidden="true">✦</span>
                      <h4 style={styles.relationshipGuidanceSectionTitle}>
                        {synText('Fortalezas', 'Strengths')}
                      </h4>
                    </div>

                    <div style={styles.relationshipGuidanceList}>
                      {relationshipStrengths.map((item, idx) => (
                        <div key={`strength-${idx}`} style={styles.relationshipGuidanceItem}>
                          <span style={styles.relationshipGuidanceDot} aria-hidden="true" />
                          <p style={styles.relationshipGuidanceText}>
                            {localizeNarrativeText(item)}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : null}

                {normalizeArray(result.challenges).length ? (
                  <div style={styles.relationshipGuidanceSection}>
                    <div style={styles.relationshipGuidanceSectionHeader}>
                      <span style={styles.relationshipGuidanceSectionIcon} aria-hidden="true">◇</span>
                      <h4 style={styles.relationshipGuidanceSectionTitle}>
                        {synText('Desafíos', 'Challenges')}
                      </h4>
                    </div>

                    <div style={styles.relationshipGuidanceList}>
                      {result.challenges.map((item, idx) => (
                        <div key={`challenge-${idx}`} style={styles.relationshipGuidanceItem}>
                          <span style={styles.relationshipGuidanceDot} aria-hidden="true" />
                          <p style={styles.relationshipGuidanceText}>
                            {localizeNarrativeText(item)}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : null}

                {normalizeArray(result.advice).length ? (
                  <div style={styles.relationshipGuidanceSection}>
                    <div style={styles.relationshipGuidanceSectionHeader}>
                      <span style={styles.relationshipGuidanceSectionIcon} aria-hidden="true">↗</span>
                      <h4 style={styles.relationshipGuidanceSectionTitle}>
                        {synText('Consejos', 'Guidance')}
                      </h4>
                    </div>

                    <div style={styles.relationshipGuidanceList}>
                      {result.advice.map((item, idx) => (
                        <div key={`advice-${idx}`} style={styles.relationshipGuidanceItem}>
                          <span style={styles.relationshipGuidanceDot} aria-hidden="true" />
                          <p style={styles.relationshipGuidanceText}>
                            {localizeNarrativeText(item)}
                          </p>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          ) : null}

          <SectionFrame title={null} right={null}>
  <div style={{ display: 'grid', gap: 14 }}>
    <div style={styles.integrationHero}>
      <div aria-hidden style={styles.integrationGlowA} />
      <div aria-hidden style={styles.integrationGlowB} />

      <div style={styles.integrationHeader}>
        <p style={styles.integrationEyebrow}>{synText('Integración de la lectura', 'Reading integration')}</p>
        <h3 style={styles.integrationTitle}>{synText('Síntesis Zodiacus', 'Zodiacus synthesis')}</h3>

        <p style={styles.integrationText}>
          {synText('La sinastría no determina el destino de una relación, pero sí revela la arquitectura energética del vínculo. En esta lectura aparecen señales claras sobre atracción, resonancia emocional, estabilidad potencial y aprendizajes evolutivos entre ambas cartas.', 'Synastry does not determine a relationship’s destiny, but it reveals the connection’s energetic architecture. This reading highlights attraction, emotional resonance, potential stability, and growth lessons between both charts.')}
        </p>

        <p style={styles.integrationText}>
          {synText('Usá esta información como una brújula: observá qué partes del vínculo fluyen naturalmente, qué dinámicas requieren conciencia y cómo cada persona activa dimensiones distintas en la vida de la otra.', 'Use this information as a compass: notice which parts of the connection flow naturally, which dynamics require awareness, and how each person activates different areas in the other’s life.')}
        </p>
      </div>

      <div style={styles.integrationPillRow}>
        <span style={styles.integrationPill}>{synText('Atracción', 'Attraction')}</span>
        <span style={styles.integrationPill}>{synText('Resonancia emocional', 'Emotional resonance')}</span>
        <span style={styles.integrationPill}>{synText('Dinámica kármica', 'Karmic dynamics')}</span>
        <span style={styles.integrationPill}>{synText('Aprendizaje mutuo', 'Mutual growth')}</span>
      </div>
    </div>

          
            </div>
          </SectionFrame>

          {guidedPanel}
        </div>
      ) : null}
      {shareModalOpen && sharePayload ? (
        <div style={styles.shareBackdrop} onClick={() => setShareModalOpen(false)}>
          <div style={styles.shareModal} onClick={(event) => event.stopPropagation()}>
            <div style={styles.shareModalHeader}>
              <div>
                <h3 style={styles.shareModalTitle}>Compartir compatibilidad</h3>
                <p style={styles.shareModalText}>
                  {synText('Elegí cómo querés compartir esta lectura premium de Zodiacus.', 'Choose how you want to share this premium Zodiacus reading.')}
                </p>
              </div>
              <button
                type="button"
                style={styles.shareCloseButton}
                onClick={() => setShareModalOpen(false)}
                aria-label={synText('Cerrar modal de compartir', 'Close sharing dialog')}
              >
                ×
              </button>
            </div>

            <div style={styles.shareModalBody}>
              <div style={styles.sharePreview}>
                <p style={styles.sharePreviewTitle}>Vista previa</p>
                <div style={{ display: 'grid', gap: 8, justifyItems: 'center' }}>
  <p style={styles.sharePreviewPair}>{sharePayload.explicitNameA || sharePayload.shareNameA}</p>
  <p style={{ ...styles.sharePreviewPair, fontSize: 18, color: '#D9C7FF' }}>{sharePayload.signA || '—'}</p>
  <p style={{ ...styles.sharePreviewPair, fontSize: 16, color: '#F7D774', margin: '2px 0' }}>✦</p>
  <p style={styles.sharePreviewPair}>{sharePayload.explicitNameB || sharePayload.shareNameB}</p>
  <p style={{ ...styles.sharePreviewPair, fontSize: 18, color: '#D9C7FF' }}>{sharePayload.signB || '—'}</p>
</div>
                <div style={styles.sharePreviewMeta}>
                  <span style={styles.microBadge}>{`Compatibilidad ${sharePayload.compatibility}%`}</span>
                  {sharePayload.attraction ? <span style={styles.microBadge}>{`Atracción ${sharePayload.attraction}%`}</span> : null}
                  {sharePayload.emotional ? <span style={styles.microBadge}>{`Emoción ${sharePayload.emotional}%`}</span> : null}
                  {sharePayload.stability ? <span style={styles.microBadge}>{`Estabilidad ${sharePayload.stability}%`}</span> : null}
                  {sharePayload.karmic ? <span style={styles.microBadge}>{`Kármico ${sharePayload.karmic}%`}</span> : null}
                </div>
              </div>

              <div style={styles.shareVisualShell}>
  <div style={styles.shareVisualStage}>
  <div style={styles.shareCardFrame}>
    <img
      alt="Card premium de compatibilidad Zodiacus"
      src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(buildShareCardSvg(sharePayload))}`}
      style={styles.shareVisualImage}
    />
  </div>
</div>
  <div style={styles.shareVisualActions}>
                  <button
                    type="button"
                    style={{
                      ...styles.shareActionButton,
                      ...((shareCardBusy) ? styles.buttonDisabled : null),
                    }}
                    disabled={shareCardBusy}
                    onClick={handleDownloadShareCard}
                  >
                    {shareCardBusy ? 'Preparando…' : 'Descargar card'}
                  </button>
                  <button
                    type="button"
                    style={{
                      ...styles.shareActionButton,
                      ...((shareCardBusy) ? styles.buttonDisabled : null),
                    }}
                    disabled={shareCardBusy}
                    onClick={handleNativeShareCard}
                  >
                    Compartir card
                  </button>
                </div>
              </div>

              <div style={shareActionsGridStyle}>
                <button
                  type="button"
                  style={styles.shareActionButton}
                  onClick={() => openShareWindow(sharePayload.whatsappUrl, 'WhatsApp')}
                >
                  WhatsApp
                </button>
                <button
                  type="button"
                  style={styles.shareActionButton}
                  onClick={() => openShareWindow(sharePayload.facebookUrl, 'Facebook')}
                >
                  Facebook
                </button>
                <button
                  type="button"
                  style={styles.shareActionButton}
                  onClick={() => openShareWindow(sharePayload.telegramUrl, 'Telegram')}
                >
                  Telegram
                </button>
                <button
                  type="button"
                  style={styles.shareActionButton}
                  onClick={() => openShareWindow(sharePayload.twitterUrl, 'X / Twitter')}
                >
                  X / Twitter
                </button>
                <button type="button" style={styles.shareActionButton} onClick={handleCopyShareText}>Copiar texto</button>
                <button type="button" style={styles.shareActionButton} onClick={handleCopyShareLink}>Copiar link</button>
              </div>

             <label htmlFor="deep-share-textarea" style={styles.label}>
  Texto para compartir
</label>
<textarea
  id="deep-share-textarea"
  name="deep_share_text"
  readOnly
  value={sharePayload.shareText}
  style={styles.shareTextarea}
/>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
